<!-- <video controls autoplay>
<source src="https://fractal360-proctoring-videos.s3.ap-south-1.amazonaws.com/64e5fbd78ee8ba59fe6523cc.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20230823T123016Z&X-Amz-SignedHeaders=host&X-Amz-Expires=3599&X-Amz-Credential=AKIATWOFZ3IQZ3KLM5R6%2F20230823%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Signature=37baf9a370a0a66d6155e8f6f6d95c07a0537fbf59c5ee37e602f3f42764cb46" type="video/webm">
Your browser does not support the video tag.
</video> -->

<ng-container *ngIf="getAllAdminPermissions">
  <app-examination-top-bar #appTopBar [getAllAdminPermissions]="getAllAdminPermissions" [audioEnabled]="audioEnabled"
    [audioVideoTestPassed]="audioVideoTestPassed"
    [screenRecordingEnabled]="screenRecordingEnabled" [groundRulesVerification]="groundRulesVerification"
    [enablestepZero]="enablestepZero" [enablestepOne]="enablestepOne" [enableStepTwo]="enableStepTwo"
    [enableStepThree]="enableStepThree" [enableStepFour]="enableStepFour" [enableStepFive]="enableStepFive"
    [activeTab]="activeTab" [videoEnabled]="videoEnabled" [startedExamination]="startedExamination"

    [extensionEnabled]="extensionEnabled" [aadharPhotoCaptured]="aadharPhotoCaptured" [mobileFeedDto]="mobileFeedDto"
    (activeTabAndBreadCrumbList)="activeTabChange($event)" (navToAssessment)="navToAssessment($event)"
    (navToAssessmentRules)="navToAssessmentRules($event)" [sectionName]="currentSectionName"
    [sectionTimer]="sectionTimer" [breakInTimePopup]="sectionBreakTime" [breakTimeScreen]="breakTimeScreen"
    (timeUpForExam)="timeUpForExam($event)" (breakInTime)="breakInTime($event)"
    [allQuestionsDataForTopBar]="allQuestionsDataForTopBar" [attemptedQuestionsList]="attemptedQuestionsList"
    [isCurrentSectionProgressive]="isCurrentSectionProgressive" [totalProgressiveQuestions]="totalProgressiveQuestions"
    [showInProgressLegend]="(allIDEQuestionsIds?.length > 0) || (allJupyterQuestionsIds?.length > 0)"
    [attemptedQuestionsCount]="attemptedQuestionsCount"></app-examination-top-bar>
</ng-container>

<ng-container>
  <div [ngSwitch]="activeTab">
    <!-- <div *ngSwitchCase="-1">

      <app-ready-for-assessment></app-ready-for-assessment>
    </div> -->

    <div *ngSwitchCase="0">
      <app-install-plugin [extensionEnabled]="extensionEnabled"></app-install-plugin>
      <!-- <app-ready-for-assessment></app-ready-for-assessment> -->
    </div>

    <div *ngSwitchCase="1">
      <app-container>
        <p class="xl:text-xl 2xl:text-2xl mb-5">Audio & Video Setup</p>
        <div class="min-w-[750px] mb-6">
          <!-- In-proctoring audio/video check: live preview, 30s record,
               listen-back playback and a consent checkbox that gates Continue. -->
          <app-audio-video-setup [recordSeconds]="30" [requireConsent]="true"
            (testPassed)="onAudioVideoTestPassed($event)"></app-audio-video-setup>
        </div>
      </app-container>
    </div>

    <div *ngSwitchCase="2">
      <div>
        <div *ngIf="!imageData" class="mb-4">
          <!-- Gate on the permission: the old condition tested the
               getAdminPermissions *method*, so it was always true. -->
          <app-web-cam *ngIf="getAllAdminPermissions?.aadharPhotoCapture" (pictureTaken)="enbleStep2($event)"
            [getAllAdminPermissions]="getAllAdminPermissions" [ableToAccessCamera]="ableToAccessCamera"></app-web-cam>
        </div>
        <div *ngIf="imageData && imageData?._imageAsDataUrl"
          class="mx-4 lg:mx-20 xl:mx-32 2xl:mx-44 mt-10 md:mt-24 mb-6">
          <div class="py-6 bg-white shadow-lg rounded-lg w-[55%] mx-auto justify-center">
            <h1 class="text-primary_Text_Color xl:text-xl 2xl:text-2xl  poppinsSemiBold mb-4 text-center">
              Profile Registered
            </h1>
            <img [src]="imageData._imageAsDataUrl" class="mx-auto w-auto rounded-lg" />
          </div>
        </div>
      </div>
    </div>

    <div *ngSwitchCase="3">
      <app-container>
        <div class="bg-white rounded-lg shadow-lg p-2 px-2 mb-6">
          <img image [src]="_commonService.Images.SCREEN_SHARE" alt="" />
          <div class="bg-white border-l-4 border-Active_Otp_Border my-3 p-4 flex" role="alert">
            <div>
              <p class="text-secondary_Light_Text_Color 2xl:!text-md text-sm">
                Screen capture permission
              </p>
              <p class="2xl:text-lg txt-base">Allow permission from the browser</p>
            </div>
            <div class="ml-auto">
              <button
                class="!w-full bg-primary_Bg_Button_Color 2xl:!text-lg text-base !rounded-lg text-primary_Bg_Btn_Text_color poppinsBold 2xl:p-4 p-3"
                (click)="askForPermission()" [disabled]="screenShareData">
                Start Capture Screen
              </button>
            </div>
          </div>
        </div>
      </app-container>
    </div>

    <div *ngSwitchCase="4">
      <app-container *ngIf="!enableStepFive">
        <p class="xl:text-xl 2xl:text-2xl mb-5">Mobile Setup</p>
        <div class="bg-white rounded-lg shadow-lg p-2 px-2 mb-6">
          <div class="border text-center m-2.5 px-2.5 py-[50px] rounded-[7px] border-solid border-blue_Color">
            <div class="w-full flex justify-center">
              <span class="box w-[262.5px]">
                <!-- <qrcode [qrdata]="linkForQrCode" [width]="258" [errorCorrectionLevel]="'M'"></qrcode> -->
                <img class="ml-6" [src]="linkForQrCode" />
              </span>
              <!-- <img [src]="_commonService.Images.QR_CODE" class="w-[230px] " alt=""> -->
            </div>
            <div class="bg-white my-3 p-5 flex">
              <div class="w-full">
                <h2 class="text-md my-2">Scan the QR Code</h2>
                <p class="text-secondary_Light_Text_Color">
                  Scan the QR Code and follow the link to activate through your
                  phone
                </p>
                <p class="text-Successful_text_colour mt-5" *ngIf="mobileFeedDto.isMobileSetUpDone">
                  Mobile Setup Successful!
                </p>
              </div>
            </div>
          </div>
        </div>
      </app-container>
    </div>

    <div *ngSwitchCase="5">
      <app-container *ngIf="!enableStepFive">
        <p class="xl:text-xl 2xl:text-2xl my-5">Secondary Device Action</p>
        <div style="box-shadow: 0px 49px 74px 0px var(--attempt_test_box_shadow)"
          class="bg-white rounded-xl px-6 py-7 text-center border border-card_Bg_Color">
          <p class="text-instruction_follow_text poppins">
            Once your phone is activated, set it so your face, laptop screen, and workspace are visible per the reference image below.
          </p>
          <div class="w-full flex justify-center mt-2">
            <img [src]="_commonService.Images.VERIFY_SURROUNDING" class="w-full" alt="" />
          </div>
        </div>
      </app-container>
    </div>
  </div>
</ng-container>

<!-- *ngIf="enableStepTwo" -->
<!-- [driveData]="getSectionCardDetail" -->
<!-- <div *ngIf="enableStepFour" class="!flex !justify-center !items-center !min-h-screen">
  <div class="container md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl 2xl:max-w-screen-2xl mx-auto">
    <app-ground-rules></app-ground-rules>
  </div>
</div> -->

<div *ngIf="enableStepTwo">
  <div>
    <app-pledge-rules (navToAssessmentRule)="groundRulesVerificationDone($event)"></app-pledge-rules>
    <!-- <div class="flex gap-1 w-full px-10 mt-4">
      <div class="w-[5%] mt-1">
        <input type="checkbox" class="w-5 customCheckBox" id="myCheckbox" (click)="groundRulesVerificationDone($event)" />
      </div>
      <div class=" w-[95%]">
        <p class="text-secondary_Light_Text_Color text-sm  my-auto">
          By affixing my electronic signature below, I affirm that I have read, understood,
          and willingly agree to abide by this Honor Code..
        </p>
      </div>
    </div> -->
  </div>
</div>

<div *ngIf="enableStepThree">
  <app-assessment-rules></app-assessment-rules>
</div>

<!-- examination -->
<!-- *ngIf="enableStepThree && startedExamination" -->
<!-- main container -->

<app-loader *ngIf="loading && !showLoader"></app-loader>

<ng-container *ngIf="enableStepFive && startedExamination" appNoF5Directive (f5Pressed)="handleF5Pressed($event)">
  <div class="">
    <div class="disable-text-selection mt-[70px] 2xl:pb-10">
      <div class="mx-10 lg:mx-8 2xl:mx-12">
        <div class="flex justify-between items-end">
          <!-- <div class="relative">
            <h1
              class="text-primary_Text_Color font-semibold text-base text-left"
            >
              Sub Section
            </h1>
            <app-button
              #dropdownElement
              appOutsideClick
              (appOutsideClick)="closeDropdown()"
              [class]="
                'text-secondary_Light_Text_Color font-medium border border-card_Bg_Color rounded-xl min-w-[240px] py-[8px] pl-2 pr-6'
              "
              [buttonIconAfterTextPath]="_commonService.Images.DROPDOWN_ICON"
              [buttonIconAfterTextCss]="'absolute right-[6px]'"
              (buttonClick)="openSubSectionsPopup()"
            >
              {{ getCurrentSubcategories() }}</app-button
            >
            <div
              *ngIf="openPopupForSubSection"
              class="bg-white z-[9999] mt-[10px] w-[350px] px-[20px] py-[20px] absolute rounded-xl"
              style="box-shadow: 2px 2px 4px 4px var(--popup_arrow_box_shadow_colour)"
            >
              <div
                class="flex justify-between py-4 border-b border-card_Bg_Color"
              >
                <h1 class="text-secondary_Light_Text_Color font-medium">
                  Total Sub Sections
                </h1>
                <h1 class="text-secondary_Light_Text_Color font-medium">
                  No. Questions
                </h1>
                <h1
                  class="text-secondary_Light_Text_Color font-medium text-[25px] cursor-pointer"
                  (click)="openPopupForSubSection = false"
                >
                  <img [src]="_commonService.Images.CLOSE_ICON" alt="" />
                </h1>
              </div>
              <div class="overflow-auto max-h-[300px]">
                <div *ngIf="!isCurrentSectionProgressive">
                  <div
                    class="border-b border-card_Bg_Color"
                    *ngFor="let data of subSectionDetails; index as i"
                  >
                    <div class="flex justify-between my-3">
                      <div class="flex gap-2">
                        <div class="border-l-2 border-red-600"></div>
                        <p
                          class="text-secondary_Light_Text_Color font-medium text-sm"
                        >
                          {{ i + 1 }}
                        </p>
                        <div
                          class="text-secondary_Light_Text_Color font-medium text-sm"
                        >
                          {{ data.name }}
                        </div>
                      </div>
                      <div
                        class="text-secondary_Light_Text_Color font-medium text-sm"
                      >
                        {{ data.questionDtos.length }}
                      </div>
                      <div></div>
                    </div>
                  </div>
                </div>

                <div *ngIf="isCurrentSectionProgressive">
                  <div
                    class="border-b border-card_Bg_Color"
                    *ngFor="let data of subCategoriesData; index as i"
                  >
                    <div class="flex justify-between my-3">
                      <div class="flex gap-2">
                        <div class="border-l-2 border-red-600"></div>
                        <p
                          class="text-secondary_Light_Text_Color font-medium text-sm"
                        >
                          {{ i + 1 }}
                        </p>
                        <div
                          class="text-secondary_Light_Text_Color font-medium text-sm"
                        >
                          {{ data.key }}
                        </div>
                      </div>
                      <div
                        class="text-secondary_Light_Text_Color font-medium text-sm"
                      >
                        {{ data.value }}
                      </div>
                      <div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <div></div>
          <div>
            <ul class="xs:flex xs:justify-center inline-flex space-x-2">
              <li *ngFor="let page of getPageRange(); let i = index">
                <button [ngClass]="{
                    'grey-bg':
                      !allQuestions[page]?.visited &&
                      !allQuestions[page]?.attempted &&
                      !allQuestions[page]?.opened,
                    activeHeader: page === currentQuestionIndex,
                    attempted:
                      allQuestions[page]?.attempted &&
                      (allQuestions[page]?.answer !== '' ||
                        allQuestions[page]?.questionType === 'IDE_TYPE' ||
                        allQuestions[page]?.questionType === 'JUPYTER_NOTEBOOK'),
                    'opened-bg':
                      (allQuestions[page]?.questionType === 'IDE_TYPE' ||
                        allQuestions[page]?.questionType === 'JUPYTER_NOTEBOOK') &&
                      allQuestions[page]?.opened &&
                      !allQuestions[page]?.attempted,
                    unattempted:
                      !allQuestions[page]?.attempted &&
                      allQuestions[page]?.visited &&
                      !allQuestions[page]?.opened,
                    skipped: allQuestions[page]?.skipped
                  }"
                  class="w-10 h-10 transition-colors duration-150 rounded-full focus:shadow-outline hover:bg-indigo-100 text-next_page_text_colour poppinsBold"
                  (click)="isCurrentSectionProgressive ? '' : navigateToPage(page)">
                  <span class="2xl:text-base  text-sm">
                    {{ page + 1 }}
                  </span>
                </button>
              </li>
              <li class="relative">
                <div class="w-10 h-10 cursor-pointer" #dropdownElement appOutsideClick
                  (appOutsideClick)="closeDropdownForTotalQuestions()" (click)="openPopupForTotalQustion()">
                  <img [src]="
                      _commonService.imageBase64String.menuIconBase64String
                    " alt="" />
                </div>
                <div *ngIf="openPopupForTotalQustions"
                  class="bg-white z-[9999] mt-[10px] w-[380px] right-0 px-[20px] py-[20px] absolute rounded-xl" style="
                    box-shadow: 2px 2px 4px 4px
                      var(--popup_arrow_box_shadow_colour);
                  ">
                  <div class="flex justify-between">
                    <h1 class="text-secondary_Light_Text_Color 2xl:text-base text-sm font-medium">
                      Total Questions
                    </h1>
                    <p class="text-secondary_Light_Text_Color font-medium text-[25px] cursor-pointer"
                      (click)="openPopupForTotalQustions = false">
                      <img [src]="
                          _commonService.imageBase64String.closeIconBase64String
                        " alt="" />
                    </p>
                  </div>
                  <div class="overflow-auto max-h-[300px]">
                    <div class="grid grid-cols-6">
                      <div *ngFor="let page of getPageRangePopup(); let i = index">
                        <button [ngClass]="{
                            'grey-bg':
                              !allQuestions[page]?.visited &&
                              !allQuestions[page]?.attempted &&
                              !allQuestions[page]?.opened,
                            activeHeader: page === currentQuestionIndex,
                            attempted:
                              allQuestions[page]?.attempted &&
                              (allQuestions[page]?.answer !== '' ||
                                allQuestions[page]?.questionType === 'IDE_TYPE' ||
                                allQuestions[page]?.questionType === 'JUPYTER_NOTEBOOK'),
                            'opened-bg':
                              (allQuestions[page]?.questionType === 'IDE_TYPE' ||
                                allQuestions[page]?.questionType === 'JUPYTER_NOTEBOOK') &&
                              allQuestions[page]?.opened &&
                              !allQuestions[page]?.attempted,
                            unattempted:
                              !allQuestions[page]?.attempted &&
                              allQuestions[page]?.visited &&
                              !allQuestions[page]?.opened,
                            skipped: allQuestions[page]?.skipped
                          }"
                          class="w-10 h-10 my-1.5 transition-colors duration-150 rounded-full focus:shadow-outline hover:bg-indigo-100 text-next_page_text_colour poppinsBold"
                          (click)="
                            isCurrentSectionProgressive ? '' : navigateToPage(page)
                          ">
                          <span class="2xl:text-base  text-sm">
                            {{ page + 1 }}
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="text-center lg:text-left">
            <p class="font-extrabold text-end 2xl:text-2xl text-xl">Questions</p>
            <p *ngIf="!isCurrentSectionProgressive" class="text-gray-400 font-medium">
              {{ attemptedQuestionsCount }} /
              {{ getTotalQuestionsInSection(allQuestionsDataForTopBar) }}
              Attempted
            </p>
            <p *ngIf="isCurrentSectionProgressive" class="text-gray-400 font-medium 2xl:text-base text-sm" >
              {{ attemptedQuestionsCount }} /
              {{ totalProgressiveQuestions }} Attempted
            </p>
          </div>
        </div>

        <div class="relative mt-5">
          <!-- <div *ngIf="showIDE"
            class="flex text-secondary_Light_Text_Color poppinsMedium text-sm tracking-wider absolute ml-3 z-50"
          >
            <p (click)="goBackFromIDE()" class="my-auto">
              <img [src]="_commonService.Images.BLUE_LEFT_ARROW" class="cursor-pointer" alt="">
            </p>
          </div> -->

          <div *ngIf="currentPage != null" [ngClass]="[
              'grid',
              'xs:grid-cols-1',
              allQuestionsData?.questionType === 'IDE_TYPE' &&
              !maximizeQuestionSection &&
              minimizeQuestionSection
                ? 'md:grid-cols-[20%_80%]'
                : (allQuestionsData?.questionType === 'SQL_CODING' ||
                    allQuestionsData?.questionType === 'CODING_TYPE') &&
                  !maximizeQuestionSection &&
                  minimizeQuestionSection
                ? 'md:grid-cols-[40%_60%]'
                : !maximizeQuestionSection && minimizeQuestionSection
                ? 'md:grid-cols-2'
                : maximizeQuestionSection && !minimizeQuestionSection
                ? 'md:grid-cols-1'
                : '',
              'card-container',
              'rounded-[15px]',
              'bg-white',
              'border-[1px]',
              'border-card_Bg_Color',
              'shadow-[0px_80px_114px_0px_#031B3E0D]'
            ]">
            <div *ngIf="!isCurrentSectionProgressive" class="absolute -left-[25px] top-[50%]">
              <button (click)="moveToprevQuestion()" [disabled]="currentQuestionIndex == 0"
                class="flex items-center justify-center w-[40px] h-[40px] bg-white border border-card_Bg_Color transition-colors duration-150 rounded-full focus:shadow-outline">
                <img [src]="
                    _commonService.imageBase64String.previewQuestionBase64String
                  " alt="preview" />
              </button>
            </div>
            <div *ngIf="minimizeQuestionSection" [ngClass]="
                maximizeQuestionSection
                  ? ''
                  : 'border-r-card_Bg_Color border-[1px]'
              " class="col-span-1 px-5 py-4 border-t-0 border-b-0 rounded-tl-[15px] rounded-bl-[15px] w-full">
              <div class="flex gap-3 overflow-auto" id="question-container">
                <div class="w-full question-section-height" id="current-question">
                  <div class="flex justify-between items-center">
                    <h1 class="text-secondary_Light_Text_Color text-sm poppinsMedium">
                      Question : {{ currentQuestionIndex + 1 }}
                    </h1>
                    <img class="ml-auto cursor-pointer h-7 w-7 mr-3" (click)="toggleMaximizeQuestionSection()" [src]="
                        maximizeQuestionSection
                          ? themeBlue
                            ? _commonService.imageBase64String
                                .minimizeBlueBase64String
                            : _commonService.imageBase64String
                                .minimizeIconYellowBase64String
                          : themeBlue
                          ? _commonService.imageBase64String
                              .maximixeBlueIconBase64String
                          : _commonService.imageBase64String
                              .maximizeYellowIconBase64String
                      " alt="" *ngIf="
                        allQuestionsData?.questionType !== 'VIDEO' &&
                        allQuestionsData?.questionType !== 'TECHNICAL_QUESTION'
                      " />
                  </div>
                  <!-- <p class="text-primary_Text_Color text-lg poppinsMedium py-2.5">
                    <markdown katex [data]="allQuestionsData?.questionText" [disableSanitizer]="false">
                    </markdown>
                  </p> -->
                  <div>
                    <ng-container *ngIf="isCurrentSectionQuestionBank">
                      <p class="text-primary_Text_Color poppinsRegular py-2.5 leading-[26px] xl:text-sm">
                        <!-- For type other than MCQ -->
                        <ng-container *ngIf="allQuestionsData?.questionType!='MCQ';else mcqQuestion">
                          <markdown katex [data]="allQuestionsData?.questionText" [disableSanitizer]="false"></markdown>
                        </ng-container>
                        <!-- only for type MCQ -->
                        <ng-template #mcqQuestion>
                          <!-- <p>question text</p> -->
                          <div>
                            <pre><code [textContent]="this._commonService.sanitizeSingleP(allQuestionsData?.questionText)"></code></pre>
                          </div>
                          <!-- <markdown 
                          katex
                          [data]="this._commonService.sanitizeSingleP(allQuestionsData?.questionText)"
                          [disableSanitizer]="false"
                        ></markdown> -->
                        </ng-template>
                    </ng-container>

                    <ng-container *ngIf="
                        !isCurrentSectionQuestionBank &&
                        allQuestionsData?.questionContentDto
                      ">
                      <ng-container *ngFor="
                          let orderElement of allQuestionsData
                            ?.questionContentDto?.OrderOfElement
                        ">
                        <ng-container *ngIf="orderElement === 'Image'">
                          <ng-container *ngFor="
                              let img of allQuestionsData?.questionContentDto
                                ?.ImageBase64?.length > 0
                                ? allQuestionsData?.questionContentDto
                                    ?.ImageBase64
                                : allQuestionsData?.questionContentDto?.Image
                            ">
                            <img [src]="img" alt="Question Image" class="my-2 cursor-zoom-in"
                              (click)="openImageModal(img)" />
                          </ng-container>
                        </ng-container>

                        <ng-container *ngIf="orderElement === 'Table'">
                          <div *ngFor="
                              let table of allQuestionsData?.questionContentDto
                                ?.Table
                            " class="pb-7 pt-2 pr-3 text-primary_Text_Color poppinsRegular leading-[26px]">
                            <p class="pb-1 poppinsSemiBold">
                              <!-- {{table?.Title}} -->

                              <markdown katex [data]="table?.Title" [disableSanitizer]="false"></markdown>
                            </p>
                            <p>
                              <!-- {{table?.Table_Description}} -->

                              <markdown katex [data]="table?.Table_Description" [disableSanitizer]="false"></markdown>
                            </p>

                            <table class="custom-table my-2">
                              <thead>
                                <tr>
                                  <th *ngFor="let headerItem of table?.Header" class="poppinsSemiBold">
                                    <!-- {{ headerItem }} -->

                                    <markdown katex [data]="headerItem" [disableSanitizer]="false"></markdown>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let row of table?.Values">
                                  <td *ngFor="let cell of row">
                                    <markdown katex [data]="cell" [disableSanitizer]="false"></markdown>

                                    <!-- {{ cell ? cell : "-" }} -->
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </ng-container>

                        <ng-container *ngIf="orderElement === 'Text'">
                          <div class="flex flex-col">
                            <p
                              class="text-primary_Text_Color poppinsRegular py-2.5 leading-[26px] flex-1 text-ellipsis xl:text-sm">
                              <markdown katex [data]="
                                  allQuestionsData?.questionContentDto?.Text
                                " [disableSanitizer]="false"></markdown>
                            </p>

                            <div *ngIf="
                                allQuestionsData?.questionType === 'AUDIO' ||
                                allQuestionsData?.questionType === 'VIDEO'
                              " class="flex justify-center">
                              <img class="mx-auto max-h-[32vh] 2xl:max-h-[50vh] h-auto"
                                [src]="_commonService.Images.BOT_IMAGE" alt="" />
                            </div>
                          </div>
                        </ng-container>

                        <ng-container *ngIf="
                            allQuestionsData?.questionType === 'SQL_CODING' &&
                            allQuestionsData?.questionContentDto?.Schema
                          ">
                          <p class="text-primary_Text_Color poppinsRegular py-3 leading-[26px]">
                            <markdown katex [data]="
                                allQuestionsData?.questionContentDto?.Schema
                              " [disableSanitizer]="false"></markdown>
                          </p>
                        </ng-container>
                      </ng-container>

                      <!-- Enlarged Image Modal -->
                      <div class="modal-background" *ngIf="isEnlargeImage" (click)="closeEnlargedImage()">
                        <div class="modal-content">
                          <img [src]="
                              _commonService.imageBase64String
                                .closeIconBase64String
                            " alt="" class="absolute w-8 h-8 cursor-pointer right-[6%]" />
                          <img [src]="enlargedImageUrl" alt="Enlarged Image" class="enlarged-image"
                            (click)="closeEnlargedImage()" />
                        </div>
                      </div>
                      <!-- Enlarged Image Modal -->
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <ng-container *ngIf="!maximizeQuestionSection">
              <!-- Text Answers  -->
              <div *ngIf="allQuestionsData?.questionType === 'TEXT_TYPE'"
                class="col-span-1 question-section-height overflow-auto p-4">
                <div class="text-sm mb-5">
                  <p class="poppinsRegular text-secondary_Light_Text_Color tracking-wider">
                    ENTER RESPONSE
                  </p>
                </div>
                <!-- <p class="poppinsBold my-4">
               Lorem ipsum dolor, sit amet consectetur adipisicing elit. Saepe
               fugiat beatae harum quisquam quasi debitis facilis aperiam illum
               quos quia?
             </p> -->

                <div class="editor">
                  <ngx-editor-menu [editor]="editor" [toolbar]="toolbar">
                  </ngx-editor-menu>
                  <ngx-editor [editor]="editor" [(ngModel)]="textInput" [placeholder]="'Type here...'"
                    (ngModelChange)="textResponse($event, currentQuestionIndex)">
                  </ngx-editor>
                </div>

                <!-- <textarea
               class="w-full rounded-lg border overflow-auto m-1 border-solid border-card_Bg_Color text-[#57677E] outline-none p-2 placeholder:font-light"
               placeholder="Type here"
               name=""
               id=""
               rows="15"
               cols="30"
               [(ngModel)]="textInput"
               (ngModelChange)="textResponse($event, currentQuestionIndex)"
             ></textarea> -->
              </div>

               <div
                *ngIf="allQuestionsData?.questionType === 'FIB'"
                class="col-span-1 question-section-height overflow-auto p-6"
              >
                <!-- Single Fill in the Blank -->

                <!-- <div *ngIf="multipleBlanks?.length==1">
               <p class="poppinsBold my-4">Type in the answer for the blank</p>
               <input
               class="w-full rounded-lg border overflow-auto m-1 border-solid border-card_Bg_Color text-[#57677E] outline-none p-2 placeholder:font-light"
               placeholder="Type here"
               name=""
               id=""
               type="text"
               [(ngModel)]="fibAnswer"
             />
             </div> -->

                <!-- Multiple Fill in the Blank -->

                <!-- *ngIf="multipleBlanks?.length>1" -->
                <div>
                  <p class="poppinsBold my-4">
                    Type in the answer for the blank
                  </p>
                  <div *ngFor="let blank of multipleBlanks; index as i">
                    <span
                      *ngIf="multipleBlanks?.length > 1"
                      class="absolute ml-4 mt-3.5 text-sm text-primary_Text_Color"
                      >({{ i + 1 }})</span
                    >
                    <input
                      class="w-full rounded-lg border overflow-auto m-1 border-solid border-card_Bg_Color text-[#57677E] outline-none placeholder:font-light p-2"
                      [ngClass]="{
                        'bg-[#ECF3FA] border-card_Border_Color border-[1px]':
                          focusedInput === i && multipleBlanks?.length > 1,
                        '': focusedInput !== i,
                        'py-2 pl-11': multipleBlanks?.length > 1
                      }"
                      placeholder="Type here"
                      name=""
                      id=""
                      type="text"
                      (ngModelChange)="
                        updateFibAnswer($event, currentQuestionIndex, i)
                      "
                      (focus)="setFocus(i)"
                      (blur)="removeFocus()"
                      [ngModel]="
                        multipleBlanks?.length > 1
                          ? multipleFibAns[i]
                          : fibAnswer[i]
                      "
                      [value]="getAnswerForField(i)"
                    />
                  </div>
                </div>
              </div>
              <div *ngIf="allQuestionsData?.questionType === 'CASE_STUDY' || allQuestionsData?.questionType === 'BIGQUERY_CODING'"
                class="col-span-1 question-section-height overflow-auto p-4">
                <div>
                  <p class="poppinsBold my-4">
                   {{allQuestionsData?.questionType === 'CASE_STUDY' ? "Type in the answer for the blank": "Write the big query"}}
                  </p>
                  <div *ngFor="let blank of multipleBlanks; index as i">
                    <span *ngIf="multipleBlanks?.length > 1"
                      class="absolute ml-4 mt-3.5 text-sm text-primary_Text_Color">({{ i + 1 }})</span>
                    <textarea  [rows]="allQuestionsData?.questionType === 'BIGQUERY_CODING' ? 10 : 2" [cols]="allQuestionsData?.questionType === 'BIGQUERY_CODING' ? 40 : 20" id="fib-input-{{ i }}"
                      class="w-full rounded-lg border overflow-auto m-1 border-solid border-card_Bg_Color text-[#57677E] outline-none placeholder:font-light p-2"
                      [ngClass]="{
                        'bg-[#ECF3FA] border-card_Border_Color border-[1px]':
                          focusedInput === i && multipleBlanks?.length > 1,
                        '': focusedInput !== i,
                        'py-2 pl-11': multipleBlanks?.length > 1
                      }" placeholder="Type here" name="" id="" rows="2" (ngModelChange)="
                        updateFibAnswer($event, currentQuestionIndex, i)
                      " (focus)="setFocus(i)" (input)="autoResize(i)" (blur)="removeFocus()" [ngModel]="
                        multipleBlanks?.length > 1
                          ? multipleFibAns[i]
                          : fibAnswer[i]
                      " [value]="getAnswerForField(i)"></textarea>
                  </div>
                </div>
              </div>

              <!-- Coding Language Selection -->

              <div *ngIf="
                  allQuestionsData?.questionType === 'CODING_TYPE' &&
                  selectCodeLanguage &&
                  !codeEditor
                " class="col-span-1 p-6 question-section-height overflow-hidden">
                <div
                  class="content-container flex flex-col items-center justify-center h-full mt-9 text-primary_Text_Color">
                  <img [src]="
                      _commonService.imageBase64String
                        .selectCodingLanguageIconBase64String
                    " alt="" />
                  <p class="poppinsBold my-4">
                    Select code language to continue
                  </p>
                  <app-button #dropdownElement appOutsideClick (appOutsideClick)="closeLanguageDropdown()" [class]="
                      ' font-medium border border-card_Bg_Color rounded-xl w-[200px] py-4 pr-3 pl-5 text-left flex justify-between relative'
                    " [buttonIconAfterTextCss]="'absolute right-4 top-6'" [buttonIconAfterTextPath]="
                      _commonService.Images.SELECT_DROP_DOWN_ICON
                    " (buttonClick)="openLanguageModal()">
                    Select Language
                  </app-button>

                  <div *ngIf="languageModal" (click)="$event.stopPropagation()"
                    class="bg-white z-[9999] w-max min-w-[180px] px-[20px] pb-5 absolute rounded-xl p-4 overflow-auto max-h-[19vh] top-[38%]"
                    style="
                      box-shadow: 2px 2px 4px 4px
                        var(--popup_arrow_box_shadow_colour);
                      border: 1px solid #d4d8de;
                    ">
                    <div
                      class="uppercase text-xs text-inactive_status_text text-left border-b border-college_admin_border_color pt-1.5 pb-3 w-full">
                      Code Languages
                    </div>
                    <ng-container *ngFor="let language of codingLanguages">
                      <div *ngIf="language.id !== '01'" [ngClass]="{
                       'pl-0 text-black font-bold': language.selected,
                       '': !language.selected,
                     }" class="mt-1 py-2 hover:bg-dropdown_bg_color hover:rounded-md hover:text-black flex gap-2 items-center cursor-pointer"
                        (click)="toggleLanguageSelection(language)" [title]="language.id === '70' ? '' : ''">
                        <span *ngIf="language.selected">
                          <!-- <img
                            class="mt-2 pl-1"
                            [src]="_commonService.Images.ASSESSMENT_CHECK"
                            alt=""
                          /> -->
                          <img class="mt-2 pl-1" [src]="
                              _commonService.imageBase64String
                                .assessmentCheckBase64String
                            " alt="" />
                          9
                        </span>
                        <span *ngIf="language.id !== '01'">
                          {{ language.name }}</span>
                      </div>
                    </ng-container>
                  </div>
                  <!-- <div class="popup-arrow">
             </div> -->
                </div>
              </div>

              <!-- Code Editor -->

              <ng-container *ngIf="
                  allQuestionsData?.questionType === 'SQL_CODING' ||
                  allQuestionsData?.questionType === 'CODING_TYPE' ||
                  allQuestionsData?.questionType === 'IDE_TYPE' ||
                  allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK'
                ">
                <div *ngIf="
                    (allQuestionsData?.questionType === 'SQL_CODING' ||
                      allQuestionsData?.questionType === 'CODING_TYPE') &&
                    codeEditor
                  " class="col-span-1 question-section-height p-4">
                  <!-- <div class="flex text-sm">
                    <p
                      class="poppinsRegular text-secondary_Light_Text_Color tracking-wider"
                    >
                      ENTER RESPONSE
                    </p>
                  </div> -->
                  <!-- Language selection instruction for drive_id 102980 and 244403 and 239424-->
                  <div *ngIf="(driveData === '102980' || driveData === '244403' || driveData === '239424' || driveData === '715158') && allQuestionsData?.questionType === 'CODING_TYPE'"
                       class="bg-red-50 border-l-4 border-red-500 p-3 mb-3 rounded-md shadow-sm text-sm">
                    <div class="flex">
                      <div class="flex-shrink-0">
                        <i class="bx bx-error-circle text-red-600 text-xl"></i>
                      </div>
                      <div class="ml-3">
                        <p class="text-red-800 font-semibold">Language Selection Notice</p>
                        <p class="text-red-700 mt-1 leading-relaxed">
                          Do not attempt the 2nd coding question using the same programming language you used for the 1st question. The language for your second attempt must be different.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="flex gap-2 text-sm mb-2">
                    <p class="font-extrabold text-primary_Text_Color py-2">
                      Write your response code in
                    </p>
                    <div class="relative">
                    <app-button #dropdownElement appOutsideClick (appOutsideClick)="closeLanguageDropdown()"
                      class="text-primary_Text_Color font-bold underline flex items-center rounded-xl px-4 h-10" [ngClass]="{
                        'cursor-not-allowed':
                          allQuestionsData?.questionType === 'SQL_CODING',
                        'cursor-pointer':
                          allQuestionsData?.questionType !== 'SQL_CODING',
                        border: selectedLanguage,
                        'border-card_Bg_Color': selectedLanguage
                      }" (buttonClick)="
                        allQuestionsData?.questionType !== 'SQL_CODING' &&
                          openLanguageModal()
                      ">
                      {{ selectedLanguage }}
                      <img class="ml-2" [src]="
                          _commonService.imageBase64String
                            .dropDownIconBase64String
                        " alt="Dropdown Icon" />
                    </app-button>

                    <div *ngIf="languageModal" (click)="$event.stopPropagation()" [ngClass]="{
                        'max-h-[19vh]':
                          allQuestionsData?.questionType === 'CODING_TYPE',
                        'max-h-[14vh]':
                          allQuestionsData?.questionType !== 'CODING_TYPE'
                      }"
                      class="bg-white z-[9999] w-max min-w-[180px] px-[20px] pb-5 absolute rounded-xl top-full left-0 p-4 overflow-auto"
                      style="
                        box-shadow: 2px 2px 4px 4px
                          var(--popup_arrow_box_shadow_colour);
                      ">
                      <div
                        class="uppercase text-xs text-inactive_status_text text-left border-b border-college_admin_border_color pt-1.5 pb-3 w-full">
                        Code Languages
                      </div>
                      <ng-container *ngFor="let language of codingLanguages">
                        <div *ngIf="language.id !== '01'" [ngClass]="{
                            'pl-0 text-black font-bold': language.selected,
                            '': !language.selected
                          }"
                          class="mt-1 py-2 hover:bg-dropdown_bg_color hover:rounded-md hover:text-black flex gap-2 items-center cursor-pointer"
                          (click)="toggleSelectedLanguage(language)" [title]="language.id === '70' ? '' : ''">
                          <span class="w-5 flex items-center">
                            <!-- <img
                              *ngIf="language.selected"
                              [src]="_commonService.Images.ASSESSMENT_CHECK"
                              alt=""
                            /> -->
                            <img *ngIf="language.selected" [src]="
                                _commonService.imageBase64String
                                  .assessmentCheckBase64String
                              " alt="" />
                          </span>
                          <div>
                            {{ language.name }}
                          </div>
                        </div>
                      </ng-container>
                    </div><!-- end languageModal dropdown -->
                    </div><!-- end relative wrapper -->

                    <div class="ml-auto flex items-center gap-2">
                    <button
                      *ngIf="!isPythonLanguageSelected"
                      class="border border-card_Bg_Color text-attempt_test_code_editor_bg_color font-bold rounded-lg px-4 h-10 cursor-pointer"
                      type="button"
                      (click)="formatCurrentCode()"
                      title="Auto-indent the code">
                      Format
                    </button>
                    <button
                      class="bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color font-bold rounded-lg px-4 h-10"
                      (click)="
                        getCodingQuestionOutput(allQuestionsData.questionId)
                      " [title]="
                        testCaseProcessing
                          ? ''
                          : 'Run your code to check output'
                      " [ngClass]="
                        code == '' || testCaseProcessing
                          ? '!cursor-not-allowed'
                          : 'cursor-pointer'
                      ">
                      {{ testCaseProcessing ? "Processing..." : "Run Code" }}
                    </button>
                    </div>
                  </div><!-- end flex gap-2 -->
                  <!-- <div
               contenteditable="true"
               (input)="onInput($event)"
               class="code-editor"
               dir="ltr"
             ></div> -->

                  <div [ngClass]="minimizeQuestionSection ? '' : ''" class="flex flex-col h-[45vh] lgmid:h-[50vh]">
                    <div *ngIf="codeEditor" [ngClass]="{
                        'w-full': true,
                        'basis-[70%]': !(
                          (allQuestionsData?.questionType === 'CODING_TYPE' ||
                            allQuestionsData?.questionType === 'SQL_CODING') &&
                          bottomPanelExpanded
                        ),
                        'basis-[20%]':
                          (allQuestionsData?.questionType === 'CODING_TYPE' ||
                            allQuestionsData?.questionType === 'SQL_CODING') &&
                          bottomPanelExpanded
                      }">
                      <div class="h-full rounded-lg overflow-hidden bg-[#031a2e] p-3" [style.height]="getPanelHeight()">
                        <ng-container *ngIf="!chatGptSection; else fullEditor">
                          <app-code-editor [(ngModel)]="code" [options]="editorOptions"
                            (ngModelChange)="onCodeChange($event)" (enterPressed)="onEnterPress($event)"
                            [formatOnLoad]="true" class="h-full custom-code-editor"></app-code-editor>
                        </ng-container>

                        <ng-template #fullEditor>
                          <app-code-editor [(ngModel)]="code" [options]="editorOptions"
                            (ngModelChange)="onCodeChange($event)" (enterPressed)="onEnterPress($event)"
                            [formatOnLoad]="true" class="h-full"></app-code-editor>
                        </ng-template>
                      </div>
                    </div>

                    <div class="mt-2 bg-white rounded-lg border border-card_Bg_Color px-5 py-2 relative"
                      [ngClass]="panelClass">
                      <div *ngIf="
                          allQuestionsData?.questionType === 'CODING_TYPE' ||
                          allQuestionsData?.questionType === 'SQL_CODING'
                        "
                        class="absolute left-1/2 top-0 transform -translate-x-1/2 -translate-y-1/4 z-30 pointer-events-auto">
                        <button *ngIf="testCasesList?.length > 0" (click)="toggleBottomPanel()" type="button"
                          aria-label="Toggle test result" class="flex items-center justify-center w-9 h-9 bg-white">
                          <img [src]="_commonService.Images.EXPAND_CODING" alt="toggle"
                            class="w-4 h-4 transform transition-transform duration-200"
                            [class.rotate-180]="!bottomPanelExpanded" />
                        </button>
                      </div>
                      <p class="font-extrabold text-primary_Text_Color mb-3">
                        Test Result: <span *ngIf="testCasesList?.length <= 0"
                          class="text-xs ml-2 text-gray-400 italic">{{
                          testCaseProcessing
                          ? "Processing..."
                          : "Run code to view the test cases"
                          }}</span>
                        <span *ngIf="testCasesList?.length > 0" class="text-xs" [ngClass]="
                            visibleCorrectCases > 0
                              ? 'text-[#32b586]'
                              : 'text-[#ff2626]'
                          ">({{ compiledCode }})</span>
                      </p>
                      <div *ngIf="bottomPanelExpanded" class="rounded-lg p-3" [ngClass]="
                          selectedTestCase
                            ? selectedTestCase.correct
                              ? 'bg-[#eff8f5]'
                              : 'bg-[#ffefef]'
                            : ''
                        ">
                        <div class="mb-4">
                          <ng-container *ngIf="testCasesList?.length > 0; else noCases">
                            <ng-container *ngIf="selectedTestCase">
                              <div *ngIf="
                                  selectedTestCase?.compileError &&
                                  selectedTestCase?.compileError !=
                                    'No compilation errors.'
                                " class="mb-4">
                                <p class="text-[#ff2626]">Compilation Error</p>
                              </div>

                              <div *ngIf="
                                  (selectedTestCase?.compileError ==
                                    'No compilation errors.' ||
                                    selectedTestCase?.compileError == null ||
                                    selectedTestCase?.compileError == '') &&
                                  (selectedTestCase?.runtimeError == null ||
                                    selectedTestCase?.runtimeError == '' ||
                                    selectedTestCase?.runtimeError ==
                                      'No runtime errors.')
                                " class="mb-4">
                                <p [ngClass]="
                                    selectedTestCase?.correct
                                      ? 'text-[#32b586]'
                                      : 'text-[#ff2626]'
                                  ">
                                  {{
                                  selectedTestCase?.correct
                                  ? "Test case passed"
                                  : "Test case failed"
                                  }}
                                </p>
                              </div>

                              <div *ngIf="
                                  selectedTestCase?.compileError ==
                                    'No compilation errors.' &&
                                  selectedTestCase?.runtimeError &&
                                  selectedTestCase?.runtimeError !=
                                    'No runtime errors.'
                                " class="mb-4">
                                <p class="text-[#ff2626]">Runtime Error</p>
                              </div>
                            </ng-container>

                            <div class="flex gap-2 items-center">
                              <button *ngFor="
                                  let tc of testCasesList.slice(0, 5);
                                  let i = index
                                " (click)="i < 2 ? selectTestCase(i) : null" [ngClass]="
                                  getButtonClasses(
                                    i,
                                    tc,
                                    selectedTestCase,
                                    selectedTestCaseIndex
                                  )
                                " [title]="
                                  selectedTestCase?.compileError &&
                                  selectedTestCase?.compileError !==
                                    'No compilation errors.'
                                    ? 'Compilation Error'
                                    : selectedTestCase?.runtimeError &&
                                      selectedTestCase?.runtimeError !=
                                        'No runtime errors.'
                                    ? 'Runtime Error'
                                    : tc?.correct
                                    ? 'Test case passed'
                                    : 'Test case failed'
                                ">
                                <div class="flex justify-center">
                                  <div class="flex items-center gap-2">
                                    <!-- <span
                                      *ngIf="
                                        selectedTestCase?.compileError !=
                                          'No compilation errors.'
                                      "
                                    >
                                      <span
                                        *ngIf="!tc?.correct"
                                      >
                                        <img
                                          [src]="
                                            i <= 1
                                              ? _commonService.Images.RED_CROSS
                                              : ''
                                          "
                                          alt=""
                                          class="w-2 h-2"
                                        />
                                      </span>
                                    </span> -->

                                    <span>
                                      <span *ngIf="tc?.correct">
                                        <img [src]="
                                            _commonService.Images.GREEN_TICK
                                          " alt="" />
                                      </span>
                                      <span *ngIf="!tc?.correct">
                                        <img [src]="
                                            i <= 1
                                              ? _commonService.Images.RED_CROSS
                                              : i >= 2
                                              ? _commonService.Images.BOLD_CROSS
                                              : _commonService.Images.RED_CROSS
                                          " alt="" class="w-2 h-2" />
                                      </span>
                                    </span>

                                    Case {{ i + 1 }}
                                  </div>
                                </div>
                              </button>
                            </div>
                          </ng-container>
                          <ng-template #noCases>
                            <!-- <p class="mb-2 my-auto">
                              {{
                                testCaseProcessing
                                  ? "Processing..."
                                  : "Run code to view the test cases"
                              }}
                            </p> -->
                            <!-- <p class="mb-2">Status</p>
                            <div class="flex gap-2">
                              <button
                                class="cursor-pointer bg-white border border-card_Bg_Color rounded-lg px-5 py-1.5 text-sm"
                                (click)="bottomPanelExpanded = true"
                              >
                                Case 1
                              </button>
                              <button
                                title="Run code to view"
                                class="cursor-pointer bg-[#e3ebef] border border-card_Bg_Color rounded-lg px-5 py-1.5 text-sm"
                              >
                                Case 2
                              </button>
                            </div> -->
                          </ng-template>
                        </div>

                        <ng-container *ngIf="bottomPanelExpanded">
                          <ng-container *ngIf="
                              selectedTestCaseIndex === 0 &&
                                testCasesList?.length <= 0;
                              else runtimeCases
                            ">
                            <!-- <div class="space-y-4 text-sm">
                              <div>
                                <div
                                  class="bg-[#031b3e] text-white rounded-lg p-4"
                                >
                                  <p class="poppinsSemiBold mb-2">
                                    Expected Input
                                  </p>
                                  <pre class="whitespace-pre-wrap">{{
                                    allQuestionsData?.testCaseDtos[0]
                                      ?.ExpectedInput
                                  }}</pre>
                                </div>
                              </div>

                              <div>
                                <div
                                  class="bg-[#031b3e] text-white rounded-lg p-4"
                                >
                                  <p class="poppinsSemiBold mb-2">
                                    Expected Output
                                  </p>
                                  <pre class="whitespace-pre-wrap">{{
                                    allQuestionsData?.testCaseDtos[0]
                                      ?.ExpectedOutPut
                                  }}</pre>
                                </div>
                              </div>
                            </div> -->
                          </ng-container>

                          <ng-template #runtimeCases>
                            <div *ngIf="
                                allQuestionsData?.questionType === 'CODING_TYPE'
                              ">
                              <ng-container *ngIf="
                                  selectedTestCase &&
                                  selectedTestCase?.compileError ==
                                    'No compilation errors.' &&
                                  (selectedTestCase?.runtimeError == null ||
                                    selectedTestCase?.runtimeError == '' ||
                                    selectedTestCase?.runtimeError ==
                                      'No runtime errors.')
                                ">
                                <div class="space-y-4 text-sm">
                                  <div>
                                    <div class="bg-[#031b3e] text-white rounded-lg p-4 overflow-auto">
                                      <p class="poppinsSemiBold mb-2">Input</p>
                                      <pre class="whitespace-pre-wrap">{{
                                        selectedTestCase.input
                                      }}</pre>
                                    </div>
                                  </div>

                                  <div>
                                    <div class="bg-[#031b3e] text-white rounded-lg p-4 overflow-auto">
                                      <p class="poppinsSemiBold mb-2">Output</p>
                                      <pre class="whitespace-pre-wrap">{{
                                        selectedTestCase.output
                                      }}</pre>
                                    </div>
                                  </div>

                                  <div>
                                    <div class="bg-[#031b3e] text-white rounded-lg p-4 overflow-auto">
                                      <p class="poppinsSemiBold mb-2">
                                        Expected Output
                                      </p>
                                      <pre class="whitespace-pre-wrap">{{
                                        selectedTestCase.expectedOutput
                                      }}</pre>
                                    </div>
                                  </div>
                                </div>
                              </ng-container>

                              <ng-container *ngIf="
                                  selectedTestCase &&
                                  ((selectedTestCase?.compileError &&
                                    selectedTestCase?.compileError !==
                                      'No compilation errors.') ||
                                    (selectedTestCase?.runtimeError &&
                                      selectedTestCase?.runtimeError !=
                                        'No runtime errors.'))
                                ">
                                <div>
                                  <div class="bg-[#031b3e] text-white rounded-lg p-4 overflow-auto">
                                    <pre class="whitespace-pre-wrap">{{
                                      selectedTestCase?.compileError &&
                                      selectedTestCase?.compileError !==
                                        "No compilation errors."
                                        ? selectedTestCase?.compileError
                                        : selectedTestCase?.runtimeError
                                    }}</pre>
                                  </div>
                                </div>
                              </ng-container>
                            </div>

                            <div *ngIf="
                                allQuestionsData?.questionType === 'SQL_CODING'
                              ">
                              <ng-container *ngIf="
                                  selectedTestCase &&
                                  selectedTestCase?.compileError == null
                                ">
                                <div class="space-y-4 text-sm">
                                  <div>
                                    <div class="bg-[#031b3e] text-white rounded-lg p-4 overflow-auto">
                                      <p class="poppinsSemiBold mb-2">Input</p>
                                      <pre class="whitespace-pre-wrap">{{
                                        selectedTestCase.input
                                      }}</pre>
                                    </div>
                                  </div>

                                  <div>
                                    <div class="bg-[#031b3e] text-white rounded-lg p-4 overflow-auto">
                                      <p class="poppinsSemiBold mb-2">Output</p>
                                      <pre class="whitespace-pre-wrap">{{
                                        selectedTestCase.output
                                      }}</pre>
                                    </div>
                                  </div>

                                  <div>
                                    <div class="bg-[#031b3e] text-white rounded-lg p-4 overflow-auto">
                                      <p class="poppinsSemiBold mb-2">
                                        Expected Output
                                      </p>
                                      <pre class="whitespace-pre-wrap">{{
                                        selectedTestCase.expectedOutput
                                      }}</pre>
                                    </div>
                                  </div>
                                </div>
                              </ng-container>

                              <ng-container *ngIf="
                                  selectedTestCase &&
                                  selectedTestCase?.compileError !== null
                                ">
                                <div>
                                  <div class="bg-[#031b3e] text-white rounded-lg p-4 overflow-auto">
                                    <pre class="whitespace-pre-wrap">{{
                                      selectedTestCase.compileError
                                    }}</pre>
                                  </div>
                                </div>
                              </ng-container>
                            </div>
                          </ng-template>
                        </ng-container>

                        <ng-template #pickCase>
                          <!-- <p class="text-gray-500">Select a test case to view details</p> -->
                        </ng-template>
                      </div>
                    </div>

                    <!-- <div
                        class="flex h-14 rounded-b-lg bg-attempt_test_code_editor_bg_color"
                      >
                        <p class="text-white pl-4 !mt-4 text-sm">
                          {{ compiledCode }}
                        </p>

                        <div class="flex pl-2" *ngIf="isLoading">
                          <img
                          class="-ml-6"
                          alt=""                       
                          [src]="_commonService.imageBase64String.dualRingGifBase64String"
                           />
                          <p
                            class="text-white my-auto animate-pulse tracking-wide"
                          >
                            Processing...
                          </p>
                        </div>

                        <button
                          class="absolute right-1 m-2 bg-skyish_blue_Color px-2 py-2.5 mt-1.5 rounded-lg text-white text-sm tracking-wide"
                          [ngClass]="
                            code == ''
                              ? '!cursor-not-allowed'
                              : 'cursor-pointer'
                          "
                          (click)="
                            getCodingQuestionOutput(allQuestionsData.questionId)
                          "
                        >
                          Execute & Test
                          <img [src]="_commonService.imageBase64String.executeCodeIconBase64String" class="inline w-4" alt="">
                        </button>
                      </div> -->

                    <!-- <div *ngIf="jupyterNotebookEnabled" class="w-full">
                      <iframe
                        [src]="jupyterNotebookName"
                        height="100%"
                        width="100%"
                        frameborder="0"
                        class="h-[33vh] md:h-[38vh] lg:h-[45vh] p-2xl:h-[55vh] shadow"
                      ></iframe>
                    </div> -->

                    <div *ngIf="!minimizeQuestionSection" class="text-white w-full hidden"
                      [ngStyle]="{ 'max-width': '60%' }">
                      <!-- <div class="bg-[#111827] h-[500px] p-4 rounded-b-lg"> -->
                      <!-- <pre [innerHTML]="compiledCode" class="text-sm overflow-auto max-h-[450px]"></pre> -->
                      <div *ngIf="isLoading" class="flex justify-center items-center h-full">
                        <iframe src="https://giphy.com/embed/LESpNIDaNBUcRIPzng" width="70" height="70"
                          style="margin-left: 25%" frameBorder="0" class="giphy-embed" allowFullScreen></iframe>
                        <p>
                          <a href="https://giphy.com/gifs/gears-setting-configure-LESpNIDaNBUcRIPzng">via GIPHY</a>
                        </p>
                      </div>
                      <div *ngIf="!isLoading" class="h-full">
                        <app-code-editor [(ngModel)]="compiledCode" [options]="outputOptions"
                          (enterPressed)="onEnterPress($event)" (pasteBlocked)="onOutputPaste(null)" class="h-full">
                        </app-code-editor>
                      </div>
                      <div class="h-11 rounded-b-lg bg-attempt_test_code_editor_bg_color p-3 poppinsMedium">
                        Output
                      </div>

                      <!-- </div> -->
                    </div>
                  </div>
                </div>
                <div *ngIf="
                    allQuestionsData?.questionType === 'SQL_CODING' &&
                    !codeEditor
                  " class="flex justify-center items-center h-full">
                  <img alt="" [src]="
                      _commonService.imageBase64String.dualRingGifBase64String
                    " />
                </div>

                <div *ngIf="jupyterNotebookEnabled && jupyterNotebookName" class="w-full" id="jupyter-container">
                  <!-- <iframe
                    id="jupyter-iframe"
                    [src]="jupyterNotebookName"
                    height="100%"
                    width="100%"
                    frameborder="0"
                    [ngClass]="chatGptSection ? 'ideHeight1' : 'ideHeight2'"
                    class="shadow-md"
                    (load)="onIframeLoad()"
                  ></iframe> -->
                  <iframe *ngIf="jupyterNotebookName" id="jupyter-iframe" [src]="jupyterNotebookName" height="100%"
                    width="100%" frameborder="0" [ngClass]="chatGptSection ? 'ideHeight1' : 'ideHeight2'"
                    class="shadow-md" (load)="onIframeLoad()"></iframe>
                </div>

                <!-- Maximize Code Editor -->

                <ng-container>
                  <!-- <div
                 *ngIf="!minimizeQuestionSection"
                 class="bg-card_Bg_Color h-[68.5vh] absolute top-0 left-[2%] w-[1px] mx-4"
               ></div> -->

                  <img [ngClass]="
                      allQuestionsData?.questionType === 'IDE_TYPE'
                        ? minimizeQuestionSection
                          ? 'left-[18%]'
                          : 'left-[-1.5%] !rotate-90'
                        : allQuestionsData?.questionType === 'CODING_TYPE' ||
                          allQuestionsData?.questionType === 'SQL_CODING'
                        ? minimizeQuestionSection
                          ? 'left-[38.5%]'
                          : 'left-[-1.5%] !rotate-90'
                        : minimizeQuestionSection
                        ? 'left-[48.5%]'
                        : 'left-[-1.5%] !rotate-90'
                    " (click)="expandCodeEditor()" class="h-6 w-6 cursor-pointer absolute bottom-[50%] -rotate-90"
                    [src]="
                      _commonService.imageBase64String.expandGifBase64String
                    " alt="" />
                </ng-container>
              </ng-container>

              <!-- Code Editor End-->

              <!-- ChatGpt Start-->

              <ng-container *ngIf="this.allQuestionsDataForTopBar?.isChatEnabled">
                <!-- <img
                  *ngIf="!chatGptSection"
                  (click)="enableChatGpt()"
                  [src]="_commonService.Images.CHATGPT"
                  alt=""
                  class=" w-[11%]"
                /> -->

                <!-- <div
               class="absolute bottom-0 right-36 cursor-pointer border border-card_Bg_Color rounded-lg px-2 py-1.5 flex gap-2"
               (click)="toggleIDE()"
             >
             <p  class="text-primary_Text_Color text-sm poppinsMedium pt-[6px]"> Run IDE </p>
             <img [src]="_commonService.Images.IDE_ICON" class="w-8 h-8" alt="" />
             </div> -->
                <div *ngIf="
                    !chatGptSection &&
                    jupyterNotebookEnabled &&
                    jupyterNotebookName
                  " #scrollContainer
                  class="absolute cursor-pointer border border-card_Bg_Color rounded-lg px-2 py-1.5 flex gap-2"
                  [ngClass]="
                    !chatGptSection ? 'right-6 bottom-2' : 'right-0  bottom-0'
                  " (click)="enableChatGpt()">
                  <p class="text-primary_Text_Color text-sm poppinsMedium pt-[6px]">
                    Chat GPT
                  </p>
                  <img [src]="_commonService.Images.CHATGPT_ICON" alt="" />
                </div>

                <input *ngIf="chatGptSection" type="text" placeholder="Enter your input here" [ngClass]="
                    minimizeQuestionSection
                      ? '!w-[49.5%] right-[0.35rem]'
                      : '!w-[96.5%] right-0.5'
                  " class="inputStyle prompt-input" [(ngModel)]="userInput" (keyup.enter)="sendMessage()" />

                <img *ngIf="chatGptSection" [src]="_commonService.Images.ARROW_UP" alt=""
                  class="absolute bottom-4 right-6 cursor-pointer" (click)="sendMessage()" />

                <div *ngIf="chatGptSection" [ngClass]="
                    minimizeQuestionSection ? 'py-5 px-10' : 'py-5 px-16'
                  " class="col-span-1 max-h-[60vh] 2xl:max-h-[70vh] overflow-auto">
                  <div class="flex text-secondary_Light_Text_Color poppinsMedium text-sm tracking-wider">
                    <p (click)="backToCodeEditor()" class="my-auto">
                      <i class="bx bx-left-arrow-alt text-[25px] cursor-pointer mt-[6px]"></i>
                    </p>
                    <p class="my-auto">Back to Question</p>
                  </div>

                  <div *ngIf="chatHistory?.length == 0">
                    <img [src]="_commonService.Images.CHATGPT_ICON" alt="" [ngClass]="
                        minimizeQuestionSection
                          ? 'w-1/5 mt-[30%]'
                          : 'mt-[15%] w-[12%]'
                      " class="mx-auto my-auto" />
                    <p class="text-gray-600 text-xl text-center poppinsMedium pt-2">
                      Ask Anything...
                    </p>
                  </div>

                  <div *ngFor="let chat of chatHistory">
                    <div *ngIf="chat.type === 'user'" class="mt-6 flex gap-2 items-start">
                      <p class="bg-zinc-200 w-full py-3 px-4 rounded-md text-gray-600 poppinsRegular text-sm">
                        {{ chat.message }}
                      </p>
                      <img [src]="_commonService.Images.USER_PROFILE" alt="" class="self-start w-[40px]" />
                    </div>

                    <div *ngIf="chat.type === 'bot'" class="mt-4 flex items-start">
                      <img [src]="_commonService.Images.CHATGPT_ICON" alt="" class="self-start mt-2" />

                      <!-- <img
                        *ngIf="chat.loading"
                        [src]="_commonService.Images.DUAl_RING_GIF"
                        class="w-12 h-12"
                        alt=""
                      /> -->
                      <img class="w-12 h-12" alt="" [src]="
                          _commonService.imageBase64String
                            .dualRingGifBase64String
                        " />

                      <p *ngIf="!chat.loading"
                        class="bg-white w-full py-3 px-4 rounded-md text-gray-600 poppinsRegular text-sm leading-6">
                        {{ chat.message }}
                      </p>
                    </div>
                  </div>

                  <div>
                    <div *ngIf="!minimizeQuestionSection"
                      class="bg-card_Bg_Color h-[74vh] absolute top-0 left-[2%] w-[1px] mx-4"></div>

                    <img [ngClass]="
                        minimizeQuestionSection
                          ? 'left-[48%]'
                          : 'left-[1%] rotate-180'
                      " (click)="expandCodeEditor()" class="h-4 w-4 cursor-pointer absolute bottom-[50%]"
                      [src]="_commonService.Images.MAXIMIZE_ARROW" alt="" />
                  </div>
                </div>
              </ng-container>

              <!-- ChatGpt End-->

              <ng-container *ngIf="isIDELoading">
                <div class="ide-container relative" *ngIf="
                    allQuestionsData?.questionType === 'IDE_TYPE' && showIDE
                  " [ngClass]="chatGptSection ? 'ideHeight1' : 'ideHeight2'" style="
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: row;
                  ">
                  <div class="relative" [ngClass]="
                      IDECodeOutput && showPreviewPanel ? 'section1' : ''
                    " [ngStyle]="{
                      width:
                        IDECodeOutput && showPreviewPanel
                          ? 100 - previewPanelWidth + '%'
                          : '100%'
                    }" style="height: 100%" id="ide-code-container">
                    <iframe #iframeRef *ngIf="IDEContainerUrl" id="code-iframe" [loading]="'lazy'"
                      [src]="IDEContainerUrl" frameborder="0" class="ide-iframe" style="
                        width: 100%;
                        height: calc(100vh - 20.6rem);
                        border-right: 1px solid
                          var(--custom_radio_label_boder_color);
                      "></iframe>

                    <div *ngIf="!IDELoader"
                      class="flex justify-between h-13 rounded-b-lg bg-attempt_test_code_editor_bg_color absolute bottom-3 md:bottom-2 w-full">
                      <div class="pl-4 mt-4">
                            <!-- Result text + collapsible execution error -->
                            <div *ngIf="!isIDETestCaseLoading" class="relative" #execErrorWrap>
                              <div class="flex items-center flex-wrap gap-2">
                                <span class="text-white text-sm">
                                  {{ IDECompiledTestCase === null ? "" : IDECompiledTestCase }}
                                </span>
                            <button *ngIf="compile_execution_error" type="button"
                                  (click)="showExecutionError = !showExecutionError"
                              class="text-red-400 text-xs font-medium underline-offset-2 hover:underline focus:outline-none">
                                  {{ showExecutionError ? "Hide error ▴" : "Show error ▾" }}
                                </button>
                              </div>
                              <!-- opens UPWARD as a popover so it is never clipped by the bottom bar / footer -->
                          <div *ngIf="compile_execution_error && showExecutionError"
                            class="absolute bottom-full left-0 mb-2 w-[min(640px,90vw)] max-h-60 overflow-auto rounded-md border border-red-400/50 bg-[#1e1e1e] p-3 shadow-xl z-[60]">
                                <div class="flex items-center justify-between mb-1">
                                  <span class="text-red-400 text-xs font-semibold">Error</span>
                                  <button type="button" (click)="showExecutionError = false"
                                    class="text-gray-300 hover:text-white text-xs leading-none">✕</button>
                                </div>
                                <pre class="text-red-300 text-xs whitespace-pre-wrap break-words m-0 font-mono">{{ compile_execution_error }}</pre>
                              </div>
                            </div>

                        <!-- Loader -->
                        <div *ngIf="isIDETestCaseLoading" class="flex items-center gap-2 -mt-2">
                          <img alt="loader" class="w-10 h-10" [src]="
                                  _commonService.imageBase64String.dualRingGifBase64String
                                " />

                          <p class="text-white text-sm animate-pulse tracking-wide">
                            Processing...
                          </p>
                        </div>
                      </div>

                      <div class="flex gap-3 items-center">
                        <button class="m-2 bg-blue-500 px-2 py-2.5 rounded-lg text-white text-sm tracking-wide"
                          (click)="runIDETestCase()">
                          Execute & Test
                          <!-- <img
                            [src]="_commonService.Images.EXECUTE_CODE_ICON"
                            alt=""
                            class="inline w-4"
                          /> -->
                          <!-- <app-base64-images   [src]="_commonService.imageBase64String.executeCodeIconBase64String"
                            [ngClass]="'inline w-4'"
                            alt="Execute Code"
                          ></app-base64-images> -->
                          <img [src]="
                              _commonService.imageBase64String
                                .executeCodeIconBase64String
                            " class="inline w-4" alt="" />
                        </button>
                        <div *ngIf="
                            !chatGptSection &&
                            this.allQuestionsDataForTopBar?.isChatEnabled
                          " #scrollContainer
                          class="cursor-pointer border border-card_Bg_Color rounded-lg px-2 py-1.5 flex gap-2"
                          (click)="enableChatGpt()">
                          <p class="text-white text-sm poppinsMedium pt-[6px]"></p>
                          <p class="text-primary_Text_Color text-sm poppinsMedium pt-[6px]">
                            Chat GPT
                          </p>
                          <img [src]="_commonService.Images.CHATGPT_ICON" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Drag Handle -->
                  <div *ngIf="IDECodeOutput && showPreviewPanel" (mousedown)="onDragStart($event)" class="drag-handle"
                    style="
                      width: 6px;
                      margin: 0 -10px;
                      height: 100%;
                      cursor: col-resize;
                      position: relative;
                      flex-shrink: 0;
                      touch-action: none;
                      background: transparent;
                    ">
                    <!-- Visual handle indicator -->
                    <div style="
                        position: absolute;
                        top: 0;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 4px;
                        height: 100%;
                        background: #e5e7eb;
                      ">
                      <!-- Center grip indicators -->
                      <!-- <div
                        style="
                          position: absolute;
                          top: 50%;
                          left: -2px;
                          transform: translateY(-50%);
                          width: 8px;
                          height: 50px;
                          display: flex;
                          flex-direction: column;
                          justify-content: space-between;
                          padding: 5px 0;
                        "
                      >
                        <div style="width: 100%; height: 2px; background: #9ca3af; border-radius: 1px;"></div>
                        <div style="width: 100%; height: 2px; background: #9ca3af; border-radius: 1px;"></div>
                        <div style="width: 100%; height: 2px; background: #9ca3af; border-radius: 1px;"></div>
                      </div> -->
                    </div>
                  </div>

                  <!-- Preview Panel -->
                  <div *ngIf="IDECodeOutput && showPreviewPanel" class="preview-container section2"
                    [ngStyle]="{ width: previewPanelWidth + '%' }" style="
                      height: 100%;
                      display: flex;
                      flex-direction: column;
                      min-width: 0;
                    ">
                    <div class="toolbar bg-landing_page_main_colour border-b border-drag_container_border_colour" style="
                        padding: 2px 12px;
                        display: flex;
                        gap: 8px;
                        align-items: center;
                      ">
                      <button (click)="reloadPreview()"
                        class="flex items-center justify-center w-8 h-8 rounded-md hover:bg-drag_container_border_colour transition-colors duration-200"
                        style="color: #4a5568" title="Refresh Preview">
                        <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.3" />
                        </svg>
                      </button>
                      <!-- <div class="e">
                          <input
                            type="text"
                            [placeholder]="rawPreviewUrl"
                            disabled
                            [(ngModel)]="searchText"
                            class="flex-1 text-xxs text-gray-600 bg-transparent border-none outline-none placeholder-gray-400"
                          />
                      </div> -->
                    </div>

                    <iframe *ngIf="showIframe" [src]="IDEpreviewUrl" frameborder="0"
                      style="width: 100%; min-height: 0; flex: 1"></iframe>

                    <!-- Preview Console -->
                    <div id="preview-console-panel"
                      class="preview-console border-t border-drag_container_border_colour bg-white"
                      [ngStyle]="{ height: showPreviewConsole ? previewConsoleHeight + '%' : '28px' }"
                      style="display: flex; flex-direction: column; min-height: 28px; flex-shrink: 0; overflow: hidden;">
                      <div (mousedown)="onConsoleDragStart($event)" title="Drag to resize console"
                        class="hover:bg-drag_container_border_colour"
                        style="height: 5px; min-height: 5px; cursor: row-resize; flex-shrink: 0;"></div>
                      <div (click)="showPreviewConsole = !showPreviewConsole"
                        class="flex items-center justify-between px-3 bg-landing_page_main_colour cursor-pointer select-none"
                        style="height: 28px; min-height: 28px; font-size: 12px; font-weight: 600;">
                        <span class="flex items-center gap-2">
                          Console
                          <span *ngIf="previewConsoleErrorCount" class="px-1.5 rounded-full bg-red-500 text-white"
                            style="font-size: 10px;">{{ previewConsoleErrorCount }}</span>
                        </span>
                        <span class="flex items-center gap-2">
                          <button (click)="clearPreviewConsole(); $event.stopPropagation()" title="Clear console"
                            class="hover:bg-drag_container_border_colour rounded px-1"
                            style="font-size: 11px;">⊘</button>
                          <span>{{ showPreviewConsole ? "▾" : "▴" }}</span>
                        </span>
                      </div>
                      <div *ngIf="showPreviewConsole" id="preview-console-body"
                        style="flex: 1; overflow-y: auto; font-family: monospace; font-size: 11px; line-height: 1.5; padding: 4px 8px;">
                        <div *ngIf="!previewConsoleLogs.length" class="text-gray-400 italic">
                          No console output yet — interact with the preview or reload it.
                        </div>
                        <div *ngFor="let log of previewConsoleLogs" class="border-b border-gray-100"
                          style="white-space: pre-wrap; word-break: break-word;" [ngClass]="{
                            'text-red-600 bg-red-50': log.level === 'error',
                            'text-yellow-700 bg-yellow-50': log.level === 'warn',
                            'text-blue-600': log.level === 'info',
                            'text-gray-400 italic': log.level === 'system',
                            'text-gray-800': log.level === 'log' || log.level === 'debug'
                          }">{{ log.message }}</div>
                      </div>
                    </div>
                  </div>

                  <!-- IDE Preview Button -->

                  <button *ngIf="matchesFrontendCoding()" (click)="showPreviewPanel = !showPreviewPanel"
                    class="absolute top-0 right-0 transform bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color rounded-full py-2 px-3 transition"
                    [attr.title]="
                      showPreviewPanel ? 'Close Preview' : 'Open Preview'
                    " style="
                      font-size: 12px;
                      font-weight: bold;
                      border: none;
                      cursor: pointer;
                    ">
                    {{ showPreviewPanel ? "Hide Preview" : "Show Preview" }}
                  </button>

                  <div *ngIf="allQuestionsData?.questionType === 'IDE_TYPE'"
                    class="h-16 w-12 left-0 top-[265px] absolute cursor-not-allowed"></div>
                </div>
              </ng-container>

              <!-- Boolean Type Answer -->
              <div *ngIf="allQuestionsData?.questionType === 'BOOLEAN_TYPE'"
                class="col-span-1 p-6 question-section-height overflow-auto">
                <div id="donate">
                  <label *ngFor="let option of booleanOptions" class="blue poppinsRegular cursor-pointer">
                    <input class="checked" type="radio" id="[option]" name="booleanOptions" [value]="option"
                      (click)="getBooleanValue($event, currentQuestionIndex)" [checked]="
                        getOptionSelected(option, currentQuestionIndex)
                      " />
                    <span style="text-overflow: ellipsis" class="flex gap-3 2xl:text-base text-sm pl-5 py-3 my-auto">
                      {{ option }}
                    </span>
                  </label>
                </div>
              </div>

              <!-- Multiple Choice Answers -->
              <div *ngIf="
                  (allQuestionsData?.questionType === 'MCQ' ||
                    allQuestionsData?.questionType === 'MULTIPLE_IMAGE') &&
                  !chatGptSection
                " class="col-span-1 p-6 question-section-height overflow-auto">
                <ng-container class="w-full" *ngIf="allQuestionsData?.options?.length > 0">
                  <p class="poppinsRegular text-secondary_Light_Text_Color text-sm">
                    ENTER RESPONSE
                  </p>
                  <p class="text-primary_Text_Color poppinsBold 2xl:text-2xl xl:text-xl mt-2 mb-4">
                    Select any one:
                  </p>

                  <div *ngFor="
                      let option of allQuestionsData?.options;
                      let i = index
                    ">
                    <div id="donate">
                      <label class="blue poppinsRegular cursor-pointer">
                        <input class="checked" type="radio" id="" name="checkbox{{ option?.id }}" (click)="
                            selectedAnswer(option, currentQuestionIndex, null)
                          " [checked]="
                            getOptionSelectedOrNot(
                              option,
                              currentQuestionIndex,
                              null
                            )
                          " />
                        <span style="text-overflow: ellipsis" class="flex gap-3 2xl:text-base text-sm pl-5 py-3 my-auto">
                          <span class="my-auto">({{ getAlphabeticalQuestionCount(i) }})
                            &nbsp;</span>

                          <markdown katex [data]="_commonService.escapeSpecialChars(option?.Option)" [disableSanitizer]="true">
                          </markdown>
                        </span>
                      </label>
                    </div>
                  </div>
                </ng-container>

                <!-- <ng-container
 *ngIf="allQuestions[currentPage]?.questionType == _commonService.QuestionTypesEnums.FILL_IN_THE_BLANKS">
 <textarea rows="5" class="p-3 bg-body_Bg_Color rounded-md w-full h-full" cols="10"
 placeholder="Type your answer here..." name="description"
 [(ngModel)]="allQuestions[currentPage]?.selectedAnswers[0]"
 (input)="answerEntered($event.target.value)"></textarea>
 </ng-container>
 <ng-container *ngIf="allQuestions[currentPage]?.questionType == _commonService.QuestionTypesEnums.VIDEO">
 <textarea rows="5" class="p-3 bg-body_Bg_Color rounded-md w-full h-full" cols="10"
 placeholder="Type (Okay) to Proceeed..." name="description"
 [(ngModel)]="allQuestions[currentPage]?.selectedAnswers[0]"
 (input)="answerEntered($event.target.value)"></textarea>
 </ng-container>
 <ng-container *ngIf="allQuestions[currentPage]?.questionType == _commonService.QuestionTypesEnums.AUDIO">
 <div class="flex justify-between">
 <div class="poppinsRegular text-secondary_Light_Text_Color">
 RECORD RESPONSE
 </div>
 <div class="poppins">
 Max Time: 30 Sec
 </div>
 </div>
 <div class="flex h-[300px] justify-center items-center">
 <div class="bg-gray-200 rounded-full h-60 w-60 flex justify-center items-center "
 style=" box-shadow: 0px 0px 22px 0px #031B3E54;">
 <div class="bg-white p-5 h-48 w-48 rounded-full flex justify-center items-center">
 <i class='bx bx-microphone text-3xl'></i>
 </div>
 </div>
 </div>
 <div class="flex justify-center">
 <app-button (buttonClick)="recordOptionAudio()" [innerText]="'Record'"></app-button>
 </div>
 </ng-container> -->
              </div>

              <!-- Video Type Answer -->
              <div *ngIf="
                  allQuestionsData?.questionType == 'VIDEO' ||
                  allQuestionsData?.questionType == 'TECHNICAL_QUESTION'
                " class="col-span-1 p-6 question-section-height overflow-auto">
                <div class="w-full xl:h-[30%] 2xl:h-[45vh]">
                  <div class="my-2 flex justify-between">
                    <p class="text-base text-card_Bg_Color">RECORD RESPONSE</p>
                    <p class="text-base">Max Time: {{ maxVideoRecordingMinutes }} mins</p>
                  </div>
                  <div class="relative">
                    <div *ngIf="!recordedFilePreviewUrl && recorderOne">
                      <video #displayVideoSetup class="rounded-lg fixed-dimensions-assessment-video" playsinline
                        autoplay muted disablePictureInPicture disableRemotePlayback preload="metadata"></video>
                    </div>

                    <div *ngIf="recordedFilePreviewUrl && !isRecording">
                      <video [src]="recordedFilePreviewUrl" class="rounded-lg fixed-dimensions-assessment-video"
                        playsinline controls muted disablePictureInPicture disableRemotePlayback
                        preload="metadata"></video>
                    </div>

                    <div [ngClass]="
                        recorderOne && !recordedFilePreviewUrl
                          ? 'overlay-video'
                          : ''
                      "></div>
                    <div *ngIf="!isRecording && !recorderOne">
                      <video id="videoPlayer" controls class="rounded-lg fixed-dimensions-assessment-video"
                        disablePictureInPicture disableRemotePlayback preload="metadata"></video>
                      <!-- <video [src]="videoUrlForVideoQuestion" class="rounded-lg fixed-dimensions-assessment-video"
             playsinline controls muted></video> -->
                    </div>

                    <div *ngIf="isRecording">
                      <video #displayRecording class="rounded-lg fixed-dimensions-assessment-video" playsinline autoplay
                        muted disablePictureInPicture disableRemotePlayback preload="metadata"></video>
                    </div>
                    <div *ngIf="isRecording" class="flex gap-3 absolute -bottom-7 left-[45%]">
                      <button (click)="stopRecordingVideo()">
                        <img [src]="
                            _commonService.imageBase64String
                              .stopRecordVideoBase64String
                          " alt="" />
                        <!-- <img
                          [src]="_commonService.Images.STOP_RECORD_VIDEO"
                          alt="stop"
                        /> -->
                      </button>
                    </div>
                    <div *ngIf="recorderOne && !recordedFilePreviewUrl"
                      class="flex gap-3 absolute top-[45%] left-[18%] lg:left-[28%] xl:left-[33%] 2xl:left-[38%]">
                      <button (click)="startRecordingVideo()"
                        class="text-white whitespace-nowrap bg-red-500 px-6 py-2 rounded-full flex gap-2 justify-center items-center z-50">
                        <span>
                          <img [src]="
                              _commonService.imageBase64String
                                .startRecordVideoBase64String
                            " alt="start" />
                        </span>
                        Start Recording
                      </button>
                    </div>
                  </div>
                  <div class="flex justify-center items-center mt-3" *ngIf="
                      (!isRecording && !recorderOne) || recordedFilePreviewUrl
                    ">
                    <button (click)="startRecordingVideo()"
                      class="text-white whitespace-nowrap bg-primary_Text_Color px-2 py-1 rounded-full flex gap-1 justify-center items-center">
                      <span>
                        <app-svg-icon [name]="
                            _commonService.imageBase64String
                              .startRecordVideoBase64String
                          "></app-svg-icon>
                        <!-- <img
                          [src]="_commonService.imageBase64String.startRecordVideoBase64String"
                          alt="start"/> -->
                      </span>
                      Record Again
                    </button>
                  </div>
                  <div *ngIf="isRecording" class="mt-8 2xl:mt-12 text-center">
                    <p>Recording Response</p>
                    <p>{{ formatTime(recordingTime) }} / {{ formatTime(maxVideoRecordingTime) }} min</p>
                  </div>
                </div>
              </div>

              <!-- Audio Type Answer -->
              <div *ngIf="allQuestionsData?.questionType == 'AUDIO'"
                class="col-span-1 p-6 question-section-height overflow-auto">
                <div class="w-full xl:h-[30%] 2xl:h-[45vh]">
                  <div *ngIf="recorderOne && !recordedFilePreviewUrl" class="my-2 flex justify-between">
                    <p class="text-secondary_Light_Text_Color poppinsMedium tracking-wider">
                      RECORD RESPONSE
                    </p>
                    <p class="text-admin_table_text poppinsMedium">
                      Max Time: {{ maxAudioRecordingMinutes }} Minutes
                    </p>
                  </div>
                  <div class="relative">
                    <div *ngIf="!recordedFilePreviewUrl && recorderOne">
                      <audio #displayAudioSetup class="rounded-lg fixed-dimensions-assessment-audio" muted></audio>
                    </div>

                    <div *ngIf="!isRecording && !recorderOne" class="flex flex-col items-center text-center">
                      <p class="text-card_Bg_Color poppinsMedium tracking-wider mt-1">
                        <!-- <img
                          [src]="_commonService.Images.RECORDED_ICON"
                          alt=""
                          class="inline"
                        /> -->
                        <img [src]="
                            _commonService.imageBase64String
                              .recordedIconBase64String
                          " class="inline" alt="recorded" />
                        YOUR RESPONSE HAS BEEN RECORDED
                      </p>

                      <!-- <img
                        [src]="
                          playAudio
                            ? _commonService.Images.PLAY_AUDIO_ICON
                            : _commonService.Images.PAUSE_AUDIO_ICON
                        "
                        alt="Audio Control"
                        class="mt-5 mx-auto cursor-pointer"
                        (click)="toggleAudio()"
                      /> -->
                      <img [src]="
                          playAudio
                            ? _commonService.imageBase64String
                                .playAudioIconBase64String
                            : _commonService.imageBase64String
                                .pauseAudioIconBase64String
                        " alt="Audio Control" class="mt-5 mx-auto cursor-pointer" (click)="toggleAudio()" />

                      <audio #audioPlayer id="audioPlayer" controls class="hidden" (ended)="audioEnded()"></audio>
                    </div>

                    <!-- <div *ngIf="isRecording">
                           <audio
                               #displayRecording
                               class="rounded-lg fixed-dimensions-assessment-audio"
                               autoplay
                               muted
                           ></audio>
                       </div> -->
                    <div *ngIf="isRecording" class="flex flex-col items-center text-center">
                      <p class="text-card_Bg_Color poppinsMedium tracking-wider">
                        YOUR RECORDING HAS STARTED
                      </p>

                      <div class="mt-16 cursor-pointer">
                        <circle-progress (onClick)="stopRecordingAudio()" [percent]="percent" [radius]="100"
                          [outerStrokeWidth]="12" [innerStrokeWidth]="12" [space]="-10" [outerStrokeColor]="'#031B3E'"
                          [innerStrokeColor]="'#EAEDF0'" [animation]="false"></circle-progress>
                      </div>

                      <p class="text-xl mt-5">Recording Response</p>
                      <p class="text-secondary_Light_Text_Color poppinsMedium mt-2">
                        {{ formatTime(audioRecordingTime) }} / {{ formatTime(maxRecordingTime) }} min
                      </p>

                      <button (click)="stopRecordingAudio()"
                        class="text-white whitespace-nowrap bg-red-500 px-4 py-2 rounded-full flex gap-2 justify-center items-center mt-4">
                        <!-- <app-svg-icon
                          [ngClass]="'w-7 h-7'"
                          [name]="
                            _commonService.imageBase64String
                              .stopRecordVideoBase64String
                          "
                        ></app-svg-icon> -->
                        <!-- <img
                          [src]="_commonService.Images.STOP_RECORD_VIDEO"
                          alt="start"
                          class="w-7 h-7"
                        /> -->
                        Stop Recording
                      </button>
                    </div>

                    <div *ngIf="recorderOne && !recordedFilePreviewUrl"
                      class="absolute top-[45%] left-[15%] lg:left-[20%] xl:left-[25%] 2xl:left-[30%] mt-12">
                      <!-- <img
                        [src]="_commonService.Images.RECORDED_AUDIO_ICON"
                        alt=""
                      /> -->
                      <!-- <app-svg-icon
                      [name]="
                        _commonService.imageBase64String.recordedAudioIconBase64String
                      "
                    ></app-svg-icon> -->
                      <img [src]="
                          _commonService.imageBase64String
                            .recordedAudioIconBase64String
                        " alt="" />

                      <!-- <img
                        (click)="startRecordingAudio()"
                        [src]="_commonService.Images.RECORD_AUDIO_ICON"
                        alt=""
                        class="mx-auto cursor-pointer"
                      /> -->
                      <img class="mx-auto cursor-pointer" (click)="startRecordingAudio()"
                        [src]="_commonService.imageBase64String.recordAudioIcon" alt="" />
                    </div>
                  </div>

                  <div *ngIf="recordedFilePreviewUrl && !isRecording" class="mx-auto mt-8">
                    <!-- <img
                      [src]="
                        playAudio
                          ? _commonService.Images.PLAY_AUDIO_ICON
                          : _commonService.Images.PAUSE_AUDIO_ICON
                      "
                      alt="Audio Control"
                      class="mt-5 mx-auto cursor-pointer"
                      (click)="toggleAudio()"
                    /> -->
                    <img class="mt-5 mx-auto cursor-pointer" (click)="toggleAudio()" [src]="
                        playAudio
                          ? _commonService.imageBase64String
                              .playAudioIconBase64String
                          : _commonService.imageBase64String
                              .pauseAudioIconBase64String
                      " alt="" />
                    <audio #audioPlayer [src]="recordedFilePreviewUrl" class="hidden" controls muted
                      (ended)="audioEnded()"></audio>
                  </div>

                  <div class="mx-auto text-center ml-6" *ngIf="
                      (!isRecording && !recorderOne) || recordedFilePreviewUrl
                    ">
                    <p (click)="toggleAudio()" class="text-xl cursor-pointer underline -mt-4">
                      {{ playAudio ? "Play Audio" : "Pause Audio" }}
                    </p>
                    <p class="text-secondary_Light_Text_Color poppinsMedium mt-2">
                      {{displayTime}} / {{displayAudioRecordingTimeInUnits}}
                    </p>

                    <!-- <img
                      (click)="startRecordingAudio()"
                      [src]="_commonService.Images.RECORD_AGAIN_ICON"
                      alt=""
                      class="mx-auto cursor-pointer mt-4"
                    /> -->
                    <img (click)="startRecordingAudio()" [src]="
                        _commonService.imageBase64String
                          .recordBtnAgainIconBase64String
                      " alt="" class="mx-auto cursor-pointer mt-4" />
                  </div>
                </div>
              </div>
            </ng-container>

            <div *ngIf="!isCurrentSectionProgressive" class="absolute -right-[25px] top-[50%]">
              <button (click)="moveToNextQuestion('')" [disabled]="
                  currentQuestionIndex >=
                  getTotalQuestionsInSection(allQuestionsDataForTopBar) - 1
                "
                class="flex items-center justify-center w-[40px] h-[40px] text-card_Bg_Color bg-white border border-card_Bg_Color transition-colors duration-150 rounded-full focus:shadow-outline xl:text-sm">
                <img [src]="
                    _commonService.imageBase64String.nextQuestionBase64String
                  " alt="next" />
              </button>
            </div>
          </div>
        </div>

        <div class="flex justify-between gap-10 my-4">
          <div class="flex gap-4">
            <app-button [class]="
                'bg-white border border-card_Bg_Color py-3 px-4 font-bold rounded-xl flex items-center xl:text-sm'
              " (buttonClick)="endAssessment()" [innerText]="
                isLastSection == true ? 'End Assessment' : 'End Section'
              ">
            </app-button>

            <p (click)="allQuestions[currentQuestionIndex]?.isReported?'':openReportQuestionPopup()"
              class="poppinsRegular text-secondary_Light_Text_Color ml-auto underline italic text-sm my-auto"
              [ngClass]="allQuestions[currentQuestionIndex]?.isReported?'cursor-not-allowed':'cursor-pointer'">
              {{ allQuestions[currentQuestionIndex]?.isReported?'Reported question':'Report question'}}
            </p>
          </div>

          <div *ngIf="
              getAllAdminPermissions.mobileFeedCapture ||
              getAllAdminPermissions.verifySurroundings
            ">
            <app-button [class]="
                'bg-white border border-card_Bg_Color py-3 text-center px-4 rounded-xl mr-4 xl:text-sm'
              " (buttonClick)="openScanQrModal()" [innerText]="'Scan QR Code'">
            </app-button>
          </div>

          <!-- <app-button
          *ngIf="allQuestionsData?.questionType === 'IDE_TYPE'"
          [class]="
            'border border-card_Bg_Color py-3 text-center px-4  mr-4 bg-blue-500 rounded-lg text-white text-sm tracking-wide'
          "
          [innerText]="'Execute & Test'"
          (buttonClick)="runIDETestCase()"
        >
        </app-button> -->

          <div>
            <app-button *ngIf="!isCurrentSectionProgressive && !chatGptSection" [class]="
                'bg-white border border-card_Bg_Color py-3 text-center px-4 rounded-xl mr-4 xl:text-sm'
              " [disabled]="
                currentQuestionIndex >=
                getTotalQuestionsInSection(allQuestionsDataForTopBar) - 1
              " (buttonClick)="moveToNextQuestion('attemptLater')" [innerText]="'Attempt later'">
            </app-button>

            <app-button *ngIf="
                allQuestionsData?.questionType != 'SQL_CODING' &&
                allQuestionsData?.questionType != 'CODING_TYPE' &&
                allQuestionsData?.questionType !== 'JUPYTER_NOTEBOOK' &&
                allQuestionsData?.questionType !== 'IDE_TYPE' &&
                !chatGptSection &&
                !isCurrentSectionProgressive
              " [disabled]="
                disableButtonForSaveAndProceed ||
                (!isLastQuestion &&
                  allQuestions[currentQuestionIndex]?.attempted)
              " [class]="
                'bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color py-3 px-1.5 text-center rounded-xl xl:text-sm'
              " [ngClass]="videoEnabled ? '' : ''" (buttonClick)="
                isLastQuestion
                  ? saveAndProceed(currentQuestionIndex)
                  : allQuestions[currentQuestionIndex]?.selectedAnswers &&
                    allQuestions[currentQuestionIndex].selectedAnswers.length >
                      0
                  ? saveAndProceed(currentQuestionIndex)
                  : moveToNextQuestion('')
              " [innerText]="
                isLastQuestion
                  ? 'Submit Section'
                  : allQuestions[currentQuestionIndex]?.selectedAnswers &&
                    allQuestions[currentQuestionIndex].selectedAnswers.length >
                      0
                  ? (
                      isCurrentSectionProgressive
                        ? currentProgressiveIndex !=
                          totalProgressiveQuestions - 1
                        : currentQuestionIndex !=
                          getTotalQuestionsInSection(
                            allQuestionsDataForTopBar
                          ) -
                            1
                    )
                    ? 'Save & Proceed'
                    : 'Submit Section'
                  : 'Skip Question'
              "></app-button>

            <!-- progresiive -->

            <app-button *ngIf="
                allQuestionsData?.questionType != 'SQL_CODING' &&
                allQuestionsData?.questionType != 'CODING_TYPE' &&
                allQuestionsData?.questionType !== 'JUPYTER_NOTEBOOK' &&
                allQuestionsData?.questionType !== 'IDE_TYPE' &&
                !chatGptSection &&
                isCurrentSectionProgressive
              " [disabled]="disableButtonForSaveAndProceed" [class]="
                'bg-primary_Bg_Button_Color py-3 px-1.5 text-center rounded-xl xl:text-sm'
              " [ngClass]="videoEnabled ? '' : ''" (buttonClick)="saveAndProceed(currentQuestionIndex)" [innerText]="
                (
                  isCurrentSectionProgressive
                    ? currentProgressiveIndex != totalProgressiveQuestions - 1
                    : currentQuestionIndex !=
                      getTotalQuestionsInSection(allQuestionsDataForTopBar) - 1
                )
                  ? 'Save & Proceed'
                  : 'Submit Section'
              ">
            </app-button>

            <!-- <app-button
              *ngIf="
                allQuestionsData?.questionType != 'SQL_CODING' &&
                allQuestionsData?.questionType != 'CODING_TYPE' &&
                allQuestionsData?.questionType !== 'JUPYTER_NOTEBOOK' &&
                !chatGptSection
              "
              [disabled]="
              disableButtonForSaveAndProceed ||
              (!isLastQuestion && allQuestionsData?.attempted)
              "
              [class]="
                'bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color py-3 px-1.5 text-center rounded-xl'
              "
              [ngClass]="videoEnabled ? '' : ''"
              (buttonClick)="saveAndProceed(currentQuestionIndex)"
              [innerText]="
                (
                  isCurrentSectionProgressive
                    ? currentProgressiveIndex != totalProgressiveQuestions - 1
                    : currentQuestionIndex !=
                      getTotalQuestionsInSection(allQuestionsDataForTopBar) - 1
                )
                  ? 'Save & Proceed'
                  : 'Submit Section'
              "
            >
            </app-button> -->

            <!-- <app-button
              *ngIf="allQuestionsData?.questionType === 'IDE_TYPE'"
              [class]="
                'bg-primary_Bg_Button_Color py-3 px-1.5 ml-4 text-center rounded-xl'
              "
              [ngClass]="videoEnabled ? 'mr-28' : 'mr-6'"
              (buttonClick)="runIDECode()"
              [innerText]="'Run Code'"
            >
            </app-button> -->

            <app-button *ngIf="
                (allQuestionsData?.questionType === 'SQL_CODING' ||
                  allQuestionsData?.questionType === 'CODING_TYPE') &&
                !chatGptSection
              " [disabled]="disableButtonForSaveAndProceed" [class]="
                'bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color py-3 px-1.5 text-center rounded-xl'
              " [ngClass]="videoEnabled ? '/*  */' : ''" (buttonClick)="saveAndProceed(currentQuestionIndex)"
              [innerText]="
                (
                  isCurrentSectionProgressive
                    ? currentProgressiveIndex != totalProgressiveQuestions - 1
                    : currentQuestionIndex !=
                      getTotalQuestionsInSection(allQuestionsDataForTopBar) - 1
                )
                  ? 'Submit Code'
                  : 'Submit Section'
              ">
            </app-button>

            <app-button *ngIf="
                (allQuestionsData?.questionType === 'IDE_TYPE' ||
                  allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK') &&
                !chatGptSection
              " [disabled]="disableButtonForSaveAndProceed" [class]="
                'bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color py-3 px-1.5 text-center rounded-xl'
              " [ngClass]="videoEnabled ? '/*  */' : ''" (buttonClick)="
                isCurrentSectionProgressive
                  ? saveAndProceed(currentQuestionIndex)
                  : (
                      currentQuestionIndex !=
                      getTotalQuestionsInSection(allQuestionsDataForTopBar) - 1
                        ? saveAndProceed(currentQuestionIndex)
                        : saveIdeJupyterCurrentQuestion()
                    )
              " [innerText]="
                isCurrentSectionProgressive
                  ? (
                      currentProgressiveIndex != totalProgressiveQuestions - 1
                        ? 'Save & Proceed'
                        : 'Submit Section'
                    )
                  : (
                      currentQuestionIndex !=
                      getTotalQuestionsInSection(allQuestionsDataForTopBar) - 1
                        ? 'Save & Proceed'
                        : 'Save Question'
                    )
              ">
            </app-button>

            <!-- IDE/JUPYTER, NON-PROGRESSIVE, LAST question only: an explicit
                 "Submit Section" shown ALONGSIDE "Save Question", so submitting
                 the section is a separate, deliberate action from saving the
                 current question (candidate won't confuse Save with ending).
                 Routes through endAssessment() => review summary / confirm. -->
            <app-button *ngIf="
                (allQuestionsData?.questionType === 'IDE_TYPE' ||
                  allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK') &&
                !chatGptSection &&
                !isCurrentSectionProgressive &&
                currentQuestionIndex ===
                  getTotalQuestionsInSection(allQuestionsDataForTopBar) - 1
              " [class]="
                'bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color py-3 px-1.5 text-center rounded-xl ml-4'
              " (buttonClick)="endAssessment(false)" [innerText]="'Submit Section'">
            </app-button>
          </div>
        </div>
      </div>

      <footer class="fixed bottom-1 right-2" style="z-index: 9999" *ngIf="getAllAdminPermissions.video">
        <video #userVideo
          class="w-[150px] border border-gray-400 rounded shadow opacity-0 pointer-events-none absolute -left-[9999px]"
          [muted]="true" autoplay playsinline disablePictureInPicture
          controlsList="nodownload nofullscreen noremoteplayback" disableRemotePlayback preload="metadata"></video>
      </footer>
    </div>
  </div>
</ng-container>

<!-- <div *ngIf="openPopUp" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
  <div class="fixed inset-0 z-50 overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div class="rounded-lg bg-white border shadow-xl">
        <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 rounded-md">
          <h1>
            {{ modalConfirmation.heading }}
            <br />
            We are auto submitting your test with current attempts.
            <br />
            Thank you.
          </h1>
          <h1 class="text-[40px] text-[#0200ed] my-5">{{ durationMinutes }}</h1>
        </div>
      </div>
    </div>
  </div>
</div> -->

<!-- Autosubmit popup starts -->
<app-common-popup
[isOpen]="openPopUp"
[heading]="modalConfirmation.heading"
[closeButtonText]="false"
[confirmButtonText]="false"
[headingCss]="'text-center text-primary_Text_Color text-xl poppinsSemiBold mb-2 '"
>
   <div class="poppinsRegular text-primary_Text_Color text-lg">
          <h1>
            We are auto submitting your test with current attempts.
            <br />
            Thank you.
          </h1>
          <h1 class="text-[40px] text-[#0200ed] my-5">{{ durationMinutes }}</h1>
  </div>
</app-common-popup>
<!-- Autosubmit popup ends -->

<!-- Pre-assessment checklist modal -->
<div *ngIf="preCheckModalOpen" aria-labelledby="precheck-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
  <div class="fixed inset-0 z-50 overflow-y-auto">
    <div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
      <div class="rounded-xl bg-white border shadow-2xl max-w-md w-full">
        <div class="px-6 py-5 text-left">
          <div class="flex items-center mb-4">
            <span class="inline-flex w-9 h-9 rounded-full bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color items-center justify-center mr-3">
              <i class="bx bx-check text-xl"></i>
            </span>
            <div>
              <h2 id="precheck-title" class="text-lg font-semibold text-primary_Text_Color">System Requirements Check</h2>
              <p class="text-secondary_Light_Text_Color text-sm" *ngIf="lastNetworkSpeedMbps === null">
                Please ensure all requirements are met
              </p>
            </div>
          </div>

          <div class="space-y-3 max-h-80 overflow-y-auto">
            <div *ngFor="let item of preCheckResults" class="flex items-start gap-3">
              <span
                class="inline-flex shrink-0 w-6 h-6 rounded-full items-center justify-center text-white"
                [ngClass]="{
                  'bg-green-500': item.status === 'pass',
                  'bg-red-500': item.status === 'fail',
                  'bg-yellow-500': item.status === 'warn',
                  'bg-gray-300 text-gray-600': item.status === 'pending'
                }"
              >
                <i class="bx" [ngClass]="{
                    'bx-check': item.status === 'pass',
                    'bx-x': item.status === 'fail',
                    'bx-error-alt': item.status === 'warn',
                    'bx-dots-horizontal-rounded': item.status === 'pending'
                  }"></i>
              </span>
              <div>
                <p class="text-sm text-primary_Text_Color font-medium">{{ item.label }}</p>
                <p class="text-xs text-secondary_Light_Text_Color" *ngIf="item.detail">{{ item.detail }}</p>
              </div>
            </div>
          </div>

          <div class="mt-5 flex justify-center gap-3">
            <!-- Show Cancel and Retry buttons when checks fail -->
            <ng-container *ngIf="preCheckHasFailures">
              <app-button
                [class]="'bg-white border border-card_Bg_Color text-primary_Text_Color px-4 py-2 rounded-lg font-semibold'"
                (buttonClick)="cancelPreChecks()"
                [innerText]="'Cancel'">
              </app-button>
              <app-button
                [class]="'bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color px-4 py-2 rounded-lg font-semibold'"
                (buttonClick)="retryPreChecks()"
                [innerText]="'Retry'">
              </app-button>
            </ng-container>
            <!-- Show Continue button only when all checks pass -->
            <ng-container *ngIf="!preCheckHasFailures && preCheckPopUpContinue">
              <app-button
                [class]="'bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color px-4 py-2 rounded-lg font-semibold'"
                (buttonClick)="preCheckModalOpen = false"
                [innerText]="'Continue'">
              </app-button>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="openPopUpForVideoQuestion" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
  <div class="fixed inset-0 z-50 overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div class="rounded-lg bg-white border shadow-xl">
        <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 rounded-md">
          <h1>Your Response is saving please hold-on</h1>
          <div class="my-4 flex justify-center gap-2">
            <div>
              <span class="timeCounter">{{
                displayMinutesForVideoQuestion
                }}</span>
              <p class="mt-3 text-secondary_Light_Text_Color text-center text-xs">
                MIN
              </p>
            </div>
            <span class="text-secondary_Light_Text_Color mt-4">:</span>
            <div>
              <span class="timeCounter ml-1">{{
                displaySecondsForVideoQuestion
                }}</span>
              <p class="mt-3 text-secondary_Light_Text_Color text-xs text-center">
                SEC
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true" *ngIf="ristrictExitingAssessment">
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
  <div class="fixed inset-0 z-50 overflow-y-auto">
    <div class="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
      <div class="rounded-lg bg-white relative border shadow-lg">
        <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 rounded-md max-w-[725px]">
          <img
            [src]="_commonService.Images.ALLOW_ICON"
            alt=""
            class="mx-auto w-[80px]"
          />
          <img class="mx-auto w-[80px]" [src]="_commonService.imageBase64String.allowIconBase64String" alt="" />
          <div class="poppinsBold text-primary_Text_Color text-xl my-5">
            {{ modalConfirmation?.heading }}
          </div>

          <p class="text-secondary_Light_Text_Color mb-5 poppinsRegular leading-6"
            [innerHTML]="modalConfirmation.description"></p>

          <div class="flex justify-center gap-4 m-2">
            <div>
              <app-button [btnType]="'button'" [class]="
                  'bg-white border-card_Bg_Color border text-primary_Text_Color px-5 py-3 rounded-xl font-semibold tracking-wide'
                " (buttonClick)="
                  ristrictExitingAssessment = !ristrictExitingAssessment
                " [innerText]="'Cancel'"></app-button>
            </div>
            <div>
              <app-button [btnType]="'button'" [class]="
                  'bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color font-semibold py-3 px-8 rounded-xl tracking-wide'
                " (buttonClick)="
                  submitTestForProgressiveOrNonProgressive(
                    _commonService.Enums.Submit_Section
                  )
                " [innerText]="'Save'"></app-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

<!-- ristrictExitingAssessment popup starts -->
<app-common-popup
  [isOpen]="ristrictExitingAssessment"
  [imageSrc]="_commonService.imageBase64String.allowIconBase64String"
  [imageCss]="'h-16 w-16'"
  [heading]="modalConfirmation?.heading"
  [headingCss]="'text-center text-primary_Text_Color text-xl poppinsSemiBold mb-2 '"
  [isFullWidthButtons] = "true"
  [closeButtonText]="'Cancel'"
  [confirmButtonText]="'Save'"
  [confirmButtonTextCss]="'poppinsSemiBold primary_Text_Color  text-sm bg-primary_Bg_Button_Color py-3 rounded-xl'"
  [closeButtonTextCss]="'poppinsSemiBold text-btn_text_blue_color border border-attempt_test_border_color text-sm bg-white_color py-3 rounded-xl'"
  (onClose)="closeEndAssessment()"
  (onConfirm)="submitTestForProgressiveOrNonProgressive(_commonService.Enums.Submit_Section)"
>
     <p class="text-secondary_Light_Text_Color my-4 poppinsLight leading-6"
            [innerHTML]="modalConfirmation.description"></p>
</app-common-popup>
<!-- ristrictExitingAssessment popup ends -->

<!-- IDE/JUPYTER submit summary + opened-vs-saved choice starts -->
<div *ngIf="showIdeSubmitSummary"
  class="fixed inset-0 z-[9999] flex items-center justify-center bg-gray-500 bg-opacity-75 backdrop-blur-[2px]"
  [ngClass]="
    openPopUp || openPopUpForVideoQuestion || openConfirmationPopup
      ? '!z-40'
      : ''
  ">
  <div class="bg-white rounded-2xl p-6 w-[440px] max-w-[92%] shadow-xl">
    <h1 class="text-center text-primary_Text_Color text-xl poppinsSemiBold mb-4">
      {{ ideSummaryForceSubmit ? "Time's up — review & submit" : 'Review before submitting' }}
    </h1>
    <p *ngIf="ideSummaryForceSubmit"
      class="text-center text-secondary_Light_Text_Color text-sm poppinsRegular -mt-2 mb-2">
      Your section time has ended. Choose what to submit.
    </p>

    <div class="flex justify-between gap-3 my-4">
      <div class="flex-1 text-center">
        <span class="block w-4 h-4 rounded-full bg-Active_Otp_Border mx-auto mb-2"></span>
        <p class="text-secondary_Light_Text_Color text-xs poppinsRegular">Saved</p>
        <p class="text-2xl poppinsBold">{{ ideJupyterSummary.saved }}</p>
      </div>
      <div class="flex-1 text-center">
        <span class="block w-4 h-4 rounded-full bg-orange-500 mx-auto mb-2"></span>
        <p class="text-secondary_Light_Text_Color text-xs poppinsRegular">Opened</p>
        <p class="text-2xl poppinsBold">{{ ideJupyterSummary.opened }}</p>
      </div>
      <div class="flex-1 text-center">
        <span class="block w-4 h-4 rounded-full bg-add_section_border mx-auto mb-2"></span>
        <p class="text-secondary_Light_Text_Color text-xs poppinsRegular">Not attempted</p>
        <p class="text-2xl poppinsBold">{{ ideJupyterSummary.notAttempted }}</p>
      </div>
    </div>

    <p class="text-secondary_Light_Text_Color my-4 poppinsLight leading-6 text-sm text-center">
      You have <span class="poppinsSemiBold">{{ ideJupyterSummary.opened }}</span> opened
      coding question(s) that are not saved yet. Do you want to include them in your
      submission, or submit only your saved questions?
    </p>

    <div class="flex flex-col gap-3 mt-5">
      <app-button (buttonClick)="confirmIdeSubmit(true)"
        [class]="'poppinsSemiBold text-sm bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color py-3 rounded-xl w-full text-center'"
        [innerText]="'Save opened & submit all'"></app-button>
      <app-button (buttonClick)="confirmIdeSubmit(false)"
        [class]="'poppinsSemiBold text-btn_text_blue_color border border-attempt_test_border_color text-sm bg-white_color py-3 rounded-xl w-full text-center'"
        [innerText]="'Submit saved only'"></app-button>
      <app-button *ngIf="!ideSummaryForceSubmit" (buttonClick)="showIdeSubmitSummary = false"
        [class]="'poppinsRegular text-secondary_Light_Text_Color text-sm py-2 w-full text-center'"
        [innerText]="'Cancel'"></app-button>
    </div>
  </div>
</div>
<!-- IDE/JUPYTER submit summary + opened-vs-saved choice ends -->

<div *ngIf="openConfirmationPopup" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
  <div class="fixed inset-0 z-50 overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div class="rounded-lg bg-white border shadow-xl">
        <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 rounded-md max-w-[725px]">
          <div *ngIf="modalConfirmation.enableButtons">
            <!-- <img
              [src]="_commonService.Images.ALLOW_ICON"
              alt=""
              class="mx-auto w-[80px]"
            /> -->
            <img class="mx-auto w-[80px]" [src]="_commonService.imageBase64String.allowIconBase64String" alt="" />
          </div>
          <h1 [innerHTML]="modalConfirmation.heading" class="my-4"></h1>
          <p class="text-secondary_Light_Text_Color text-base my-3 poppinsLight">
            Once Submitted, you will no longer be allowed to change <br />
            exam answers. Make sure you have <br />
            attempted & saved all questions
          </p>
          <!-- <br>
  Thank you. -->
          <ng-container *ngIf="
              modalConfirmation.alertMessageType ==
                _commonService.Enums.DISABLE_AUDIO ||
              modalConfirmation.alertMessageType ==
                _commonService.Enums.DISABLE_AUDIO
            ">
            <div class="flex flex-row">
              <div class="text-center" style="flex: 1 1 0">
                <!-- <img
                  [src]="_commonService.Images.DISABLED_AUDIO_OR_VIDEO"
                  alt="disable enable video and audio image"
                /> -->
                <img [src]="
                    _commonService.imageBase64String
                      .disabldAudioOrVideoBase64String
                  " alt="disable enable video and audio image" />
              </div>
              <div style="flex: 1 1 0" class="text-left m-auto py-5 px-10">
                <h1>
                  Application is blocked from using your microphone and camera
                </h1>
                <ol class="list-decimal">
                  <li class="my-1">
                    Click the
                    <!-- <img
                      class="w-4 inline"
                      [src]="_commonService.Images.LOCK_ICON"
                      alt="lock icon"
                      srcset=""
                    /> -->
                    <img class="w-4 inline" [src]="
                        _commonService.imageBase64String.lockIconBase64String
                      " alt="lock icon" srcset="" />
                    lock icon in your browser's address bar
                  </li>
                  <li class="my-1">Turn on microphone and camera</li>
                  <!-- <li class="my-1">Modal would be closed once the camera and microphone is turned on</li> -->
                </ol>
              </div>
            </div>
          </ng-container>

          <div class="flex justify-end gap-4 my-3" *ngIf="modalConfirmation.enableButtons">
            <div>
              <app-button [btnType]="'button'" [class]="
                  'text-btn_text_blue_color font-bold py-2 px-4 rounded-xl border-2 border-attempt_test_border_color bg-white_color'
                " (buttonClick)="
                  handleCancelDisabledEventsOnModalPopup(
                    modalConfirmation.alertMessageType
                  )
                " [innerText]="'Exit and Submit Assessment'"></app-button>
            </div>
            <div>
              <app-button [btnType]="'button'" [class]="
                  'text-btn_text_blue_color font-bold py-2 px-4 rounded-xl border-2 border-attempt_test_border_color bg-white_color'
                " (buttonClick)="
                  continueExamination(modalConfirmation.alertMessageType)
                " [innerText]="'Resume Assessment'"></app-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Submit Assessment popup -->
<div *ngIf="submitTestModal" class="overlay">
  <div class="popupForUploadProfile bg-white">
    <!-- <img
      [src]="_commonService.Images.CORRECT_IMAGE"
      alt=""
      class="mx-auto mt-4"
      width="60"
    /> -->
    <img [src]="_commonService.imageBase64String.correctImageBase64String" alt="" class="mx-auto mt-4" width="60" />
    <h1 class="text-2xl text-primary_Text_Color my-4">Assessment Submitted!</h1>
    <p class="text-primary_Text_Color text-lg mt-5">
      Thanks you for Attending Drive. Your Assessment Submitted Successfully.
    </p>

    <app-button (buttonClick)="goToDashboard()" [class]="
        'bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color py-3 rounded-md font-semibold tracking-wide w-40 mt-10'
      " [innerText]="'Close'"></app-button>
  </div>
</div>

<!-- isRefreshpopup -->
<!-- <div *ngIf="isRefreshpopup" class="overlay">
  <div class="popupForRefreshPopup bg-white">
    <h1 class="text-2xl text-primary_Text_Color my-4">
      Refresh Confirmation popup!
    </h1>
    <p class="text-primary_Text_Color text-lg mt-5">
      If you want to reload the page, The assessment will submit automatically
    </p>
    <app-button (buttonClick)="isRefreshpopup = false" [class]="
        'bg-white border-card_Bg_Color border text-primary_Text_Color py-3 rounded-md font-semibold tracking-wide w-40 mt-10'
      " [innerText]="'Cancel'"></app-button>
    <app-button (buttonClick)="
        submitTestForProgressiveOrNonProgressive(
          _commonService.Enums.Reload_Assessment
        )
      " [class]="
        'bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color py-3 rounded-md font-semibold tracking-wide w-40 mt-10 ml-4'
      " [innerText]="'Reload'"></app-button>
  </div>
</div> -->

<!-- isRefreshpopup starts -->
<app-common-popup
  [isOpen]="isRefreshpopup"
  [isFullWidthButtons] = "true"
  [closeButtonTextCss]="'text-slate-600 text-sm border-slate-300 shadow-sm  poppinsSemiBold py-3 rounded-xl'"
  [confirmButtonTextCss]="'poppinsSemiBold text-primary_Bg_Btn_Text_color text-sm bg-primary_Bg_Button_Color py-3 rounded-xl'"
  [closeButtonTextCss]="'text-slate-600 text-sm border-slate_300 shadow-sm  poppinsSemiBold py-3 rounded-xl'"
  [closeButtonText]="'Cancel'"
  [confirmButtonText]="'Yes, Reload'"
  (onClose)="isRefreshpopup = false"
  (onConfirm)="submitTestForProgressiveOrNonProgressive(_commonService.Enums.Reload_Assessment)"
>
 <h1 class="text-2xl text-primary_Text_Color my-4 poppinsSemiBold">
       Refresh Confirmation popup !
  </h1>
  <p class="text-secondary_Light_Text_Color mt-5 poppinsRegular">
    If you want to reload the page, The assessment will submit automatically
  </p>
</app-common-popup>
<!-- isRefreshpopup ends -->

<!-- Change Window Warning Popup -->
<!-- <div *ngIf="changeWindowWarning" class="overlay">
  <div class="popupForRefreshPopup bg-white">
    <h1 class="text-2xl text-primary_Text_Color my-4">Warning!</h1>
    <p class="text-primary_Text_Color text-base mt-5">
      Attempting to switch tabs and windows during the examination is strictly
      prohibited. Further attempts to change the windows will result in
      automatic submission of the assessment.
    </p>
    <app-button (buttonClick)="changeWindowWarning = false" [class]="
        'bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color py-2 rounded-md font-semibold tracking-wide w-24 mt-10 ml-4'
      " [innerText]="'Ok'"></app-button>
  </div>
</div> -->

<!-- Change Window Warning Popup starts -->
<app-common-popup
  [isOpen]="changeWindowWarning"
  [isFullWidthButtons] = "true"
  [closeButtonText]="false"
  [confirmButtonText]="'Ok'"
  [confirmButtonTextCss]="'poppinsSemiBold text-white text-sm bg-medium_red_color py-3 rounded-xl'"
  (onConfirm)="changeWindowWarning = false"
>
<div>
  <h1 class="text-2xl text-primary_Text_Color poppinsSemiBold my-4">Warning !</h1>
   <p class="text-primary_Text_Color text-base mt-5 poppinsRegular">
     Attempting to switch tabs and windows during the examination is strictly
     prohibited. Further attempts to change the windows will result in
     automatic submission of the assessment.
   </p>
</div>
</app-common-popup>
<!-- Change Window Warning Popup ends -->

<!-- Stop Screen Share Popup -->
<!-- <div *ngIf="stopScreenShare" class="overlay"> -->
  <!-- <div class="popupForRefreshPopup bg-white sm:w-1/2 md:w-2/5 2xl:w-1/3"> -->
    <!-- <h1 class="text-xl text-primary_Text_Color my-4"> -->
      <!-- <img
        [src]="_commonService.Images.ALLOW_ICON"
        alt=""
        class="mx-auto w-[80px]"
      /> -->
      <!-- <img class="mx-auto w-[80px]" [src]="_commonService.imageBase64String.allowIconBase64String" alt="" />
      <h1 class="my-2">
        Your assessment will be auto submitted if you stop screen share
      </h1> -->
    <!-- </h1> -->
    <!-- <p class="text-secondary_Light_Text_Color text-base my-4 poppinsLight">
      Once Submitted, you will no longer be allowed to change <br />
      exam answers. Make sure you have <br />
      attempted & saved all questions
    </p> -->
    <!-- <div class="flex justify-center gap-4 my-3">
      <app-button (buttonClick)="stopScreenAndSubmit()" [class]="
          'text-btn_text_blue_color font-bold py-2 px-4 rounded-xl border-2 border-attempt_test_border_color bg-white_color'
        " [innerText]="'Stop and Submit Assessment'"></app-button>

      <app-button [btnType]="'button'" [class]="
          'text-btn_text_blue_color font-bold py-2 px-4 rounded-xl border-2 border-attempt_test_border_color bg-white_color'
        " (buttonClick)="startRecordingAndAskForPermission()" [innerText]="'Resume Assessment'"></app-button>
    </div> -->
  <!-- </div> -->
<!-- </div> -->

<app-common-popup
  [isOpen]="stopScreenShare"
  [imageSrc]="_commonService.imageBase64String.allowIconBase64String"
  [imageCss]="'h-16 w-16'"
  [heading]="'Your assessment will be auto submitted if you stop screen share'"
  [headingCss]="'text-center text-primary_Text_Color text-xl poppinsSemiBold mb-2 '"
  [isFullWidthButtons] = "true"
  [closeButtonText]="'Stop and Submit Assessment'"
  [confirmButtonText]="'Resume Assessment'"
  [confirmButtonTextCss]="'poppinsSemiBold text-btn_text_blue_color border border-attempt_test_border_color text-sm bg-white_color py-3 rounded-xl'"
  [closeButtonTextCss]="'poppinsSemiBold text-btn_text_blue_color border border-attempt_test_border_color text-sm bg-white_color py-3 rounded-xl'"
  (onClose)="stopScreenAndSubmit()"
  (onConfirm)="startRecordingAndAskForPermission()"
>
 <p class="text-secondary_Light_Text_Color text-base my-4 poppinsLight">
      Once Submitted, you will no longer be allowed to change <br />
      exam answers. Make sure you have <br />
      attempted & saved all questions
    </p>
</app-common-popup>

<div *ngIf="reportQuestionPopup" class="overlay">
  <div class="popupForReportQuestion bg-white">
    <h1 class="text-2xl text-primary_Text_Color mb-2 font-semibold">
      Report Question
    </h1>
    <p class="text-secondary_Light_Text_Color">
      Please fill the following details which helps us in understanding the
      problem better.
    </p>

    <p class="mt-5 mb-2 text-secondary_Light_Text_Color text-sm">
      What’s wrong with current question?
      <span class="text-text_warning_msg">*</span>
    </p>

    <textarea
      class="w-full rounded-lg border overflow-auto m-1 border-solid border-card_Bg_Color text-my_profile_secondary_text outline-none p-2 placeholder:font-light"
      placeholder="Enter" name="" id="" rows="4" [(ngModel)]="wrongQuestionReason"></textarea>

    <p class="mt-5 mb-2 text-secondary_Light_Text_Color text-sm">
      Any suggestions to make the question better
    </p>

    <textarea
      class="w-full rounded-lg border overflow-auto m-1 border-solid border-card_Bg_Color text-my_profile_secondary_text outline-none p-2 placeholder:font-light"
      placeholder="Enter" name="" id="" rows="4" [(ngModel)]="wrongQuestionSuggestion"></textarea>

    <div class="flex justify-end mt-2">
      <app-button (buttonClick)="resetReportQuestion()" [class]="
          'bg-white border-card_Bg_Color border text-primary_Text_Color py-3 rounded-xl font-semibold tracking-wide w-32'
        " [innerText]="'Cancel'"></app-button>
      <app-button [class]="
          'bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color py-3 rounded-xl font-semibold tracking-wide w-32 ml-4'
        " [innerText]="'Submit'" (buttonClick)="submitWrongQuestion()"></app-button>
    </div>
  </div>
</div>
<div *ngIf="newReportedQuestionsPopup=='openReport'" class="overlay" [ngClass]="
    openPopUp || openPopUpForVideoQuestion || openConfirmationPopup
      ? '!z-40'
      : '!z-50'
  ">
  <div class="popupForNewReportQuestion max-h-[90%] overflow-y-auto bg-white">

    <h1 class="text-2xl text-primary_Text_Color mb-2 font-semibold">
      Reported Questions
    </h1>

    <p class="text-secondary_Light_Text_Color mb-4">
      Please fill the following details which helps us in understanding the problem better.
    </p>

    <!-- LOOP THROUGH EACH REPORTED QUESTION -->
    <div *ngFor="let report of reportedQuestionsArray; let i = index" class="border-b pb-6 mb-6">
      <ng-container *ngFor="let orderElement of report.allQuestionData?.questionContentDto?.OrderOfElement">
        <div class="flex items-start">
          <span class="text-primary_Text_Color poppinsRegular !font-semibold py-2.5 leading-[26px] pr-2.5"> {{i+1}}.</span>
          <div class="flex-1">
            <!-- TEXT -->
            <ng-container *ngIf="orderElement === 'Text'">

              <p class="text-primary_Text_Color poppinsRegular py-2.5 leading-[26px]">
                <markdown katex 
                [data]="report.isTextExpanded ? report.allQuestionData?.questionContentDto?.Text : (report.allQuestionData?.questionContentDto?.Text | slice:0:255)" 
                [disableSanitizer]="false"></markdown>

              </p>

              <!-- VIEW MORE / VIEW LESS BUTTON -->
              <button *ngIf="report.allQuestionData?.questionContentDto?.Text?.length > 255"
                class="flex items-center text-skyish_blue_Color text-sm font-semibold cursor-pointer select-none"
                (click)="report.isTextExpanded = !report.isTextExpanded">

                {{ report.isTextExpanded ? 'View less' : 'View more' }}

                <span class="ml-1 transition-transform duration-200" [class.rotate-180]="report.isTextExpanded">
                  ▼
                </span>

              </button>

            </ng-container>

            <!-- IMAGE -->
            <ng-container *ngIf="orderElement === 'Image'">

              <ng-container *ngFor="
          let img of report.allQuestionData?.questionContentDto
            ?.ImageBase64?.length > 0
            ? report.allQuestionData?.questionContentDto?.ImageBase64
            : report.allQuestionData?.questionContentDto?.Image
        ">
                <img [src]="img" class="my-2 cursor-zoom-in" />
              </ng-container>

            </ng-container>

            <!-- TABLE -->
            <ng-container *ngIf="orderElement === 'Table'">

              <div *ngFor="let table of report.allQuestionData?.questionContentDto?.Table"
                class="pb-7 pt-2 pr-3 text-primary_Text_Color poppinsRegular leading-[26px]">

                <!-- Title -->
                <p class="pb-1 poppinsSemiBold">
                  <markdown katex [data]="table?.Title" [disableSanitizer]="false"></markdown>
                </p>

                <!-- Description -->
                <p>
                  <markdown katex [data]="table?.Table_Description" [disableSanitizer]="false"></markdown>
                </p>

                <!-- TABLE -->
                <table class="custom-table my-2">

                  <thead>
                    <tr>
                      <th *ngFor="let headerItem of table?.Header" class="poppinsSemiBold">
                        <markdown katex [data]="headerItem" [disableSanitizer]="false"></markdown>
                      </th>
                    </tr>
                  </thead>

                  <tbody>

                    <!-- SHOW LIMITED OR FULL ROWS -->
                    <tr *ngFor="
                let row of (table.isExpanded 
                  ? table?.Values 
                  : (table?.Values | slice:0:2))
              ">
                      <td *ngFor="let cell of row">
                        <markdown katex [data]="cell" [disableSanitizer]="false"></markdown>
                      </td>
                    </tr>

                  </tbody>
                </table>

                <!-- VIEW MORE BUTTON FOR TABLE -->
                <button *ngIf="table?.Values?.length > 2"
                  class="flex items-center text-blue-600 text-sm font-semibold cursor-pointer select-none"
                  (click)="table.isExpanded = !table.isExpanded">
                  {{ table.isExpanded ? 'View less' : 'View more' }}

                  <span class="ml-1 transition-transform duration-200" [class.rotate-180]="table.isExpanded">
                    ▼
                  </span>
                </button>

              </div>

            </ng-container>

          </div>

        </div>



      </ng-container>

      <!-- <p class="font-semibold text-primary_Text_Color mb-2">
        {{ i + 1 }}. 
        {{ report.allQuestionData.questionContentDto.Text }}
      </p> -->

      <p class="mt-3 mb-1 text-secondary_Light_Text_Color text-sm">
        What’s wrong with current question?
        <span class="text-text_warning_msg">*</span>
      </p>

      <textarea class="w-full rounded-lg border m-1 p-2 outline-none" rows="3" placeholder="Enter reason"
        [(ngModel)]="report.wrongQuestionReason"></textarea>
      <p class="mt-3 mb-1 text-secondary_Light_Text_Color text-sm">
        Any suggestions to make the question better
      </p>

      <textarea class="w-full rounded-lg border m-1 p-2 outline-none" rows="3" placeholder="Enter suggestion"
        [(ngModel)]="report.wrongQuestionSuggestion"></textarea>

    </div>

    <!-- Buttons -->
    <div class="flex justify-end mt-2">

      <app-button (buttonClick)="openCancelReportPopUp()" [class]="
          'bg-white border-card_Bg_Color border text-primary_Text_Color py-3 rounded-xl font-semibold tracking-wide w-32'
        " [innerText]="'Cancel'"></app-button>

      <app-button class="ml-4" [class]="
          'bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color py-3 rounded-xl font-semibold tracking-wide w-32'
        " [innerText]="'Submit'" (buttonClick)="submitAllReportedQuestion()"></app-button>

    </div>

  </div>
</div>

<!-- <div *ngIf="newReportedQuestionsPopup=='cancelReport'" class="overlay">
  <div class="popupForReportQuestion  bg-white">
    <h1 class="text-2xl text-primary_Text_Color mb-2 font-semibold">
      Confirm Cancellation
    </h1>
    <p class="text-secondary_Light_Text_Color mb-4">
      Would you like to proceed without reporting any questions?
    </p>


    <div class="flex justify-end mt-2">

      <app-button (buttonClick)="backToReportPopUp()" [class]="
          'bg-white border-card_Bg_Color border text-primary_Text_Color py-3 rounded-xl font-semibold tracking-wide w-32'
        " [innerText]="'Cancel'"></app-button>

      <app-button class="ml-4" [class]="
          'bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color py-3 rounded-xl font-semibold tracking-wide w-32'
        " [innerText]="'Yes'" (buttonClick)="resetReportedQuestion()"></app-button>

    </div>

  </div>
</div> -->

<!-- Cancel report question starts -->
<app-common-popup
  [isOpen]="newReportedQuestionsPopup=='cancelReport'"
  [isFullWidthButtons] = "true"
  [closeButtonTextCss]="'text-slate-600 text-sm border-slate-300 shadow-sm  poppinsSemiBold py-3 rounded-xl'"
  [confirmButtonTextCss]="'poppinsSemiBold text-primary_Bg_Btn_Text_color text-sm bg-primary_Bg_Button_Color py-3 rounded-xl'"
  [closeButtonTextCss]="'text-slate-600 text-sm border-slate_300 shadow-sm  poppinsSemiBold py-3 rounded-xl'"
  [closeButtonText]="'Cancel'"
  [confirmButtonText]="'Yes, Cancel'"
  (onClose)="backToReportPopUp()"
  (onConfirm)="resetReportedQuestion()"
>
 <h1 class="text-2xl text-primary_Text_Color my-4 poppinsSemiBold">
      Confirm Cancellation ?
  </h1>
  <p class="text-secondary_Light_Text_Color mt-5 poppinsRegular">
    Would you like to proceed without reporting any questions ?
  </p>
</app-common-popup>
<!-- Cancel report question starts -->


<!-- Verify Surroundings Modal -->
<!-- <div *ngIf="verifySurroundingModal" class="overlay">
  <div class="popupForReportQuestion bg-white">
    <h1 class="text-2xl text-primary_Text_Color my-2 font-semibold">
      Verify Your Surroundings
    </h1>

    <div class="w-full flex justify-center">
      <span class="box w-[262.5px]">
        <qrcode [qrdata]="linkForQrCode" [width]="258" [errorCorrectionLevel]="'M'"></qrcode>
        <img class="ml-6" [src]="linkForQrCode" />
      </span>
      <img [src]="_commonService.Images.QR_CODE" class="w-[230px] " alt="">
    </div>

    <p class="text-secondary_Light_Text_Color">
      Please move your mobile device in your surroundings to ensure that you're
      in a proper environment for the exam.
    </p>

    <p class="mt-5 mb-2 text-secondary_Light_Text_Color">
      Please make sure you are following the below requirements:
    </p>
    <ul class="list-disc ml-5 text-secondary_Light_Text_Color">
      <li>No other person is present in the room.</li>
      <li>Your desk is clear of any unauthorized materials.</li>
      <li>Your computer screen is visible in the recording.</li>
    </ul>

    <div class="flex justify-center mt-6">
      <app-button (buttonClick)="resumeExaminatioTimer()" [class]="
          'bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color py-3 rounded-xl  font-semibold tracking-wide w-32 ml-4'
        " [innerText]="'Continue'"></app-button>
    </div>
  </div>
</div> -->

 <!-- Verify Surroundings Modal starts -->
<app-common-popup
  [isOpen]="verifySurroundingModal"
  [isFullWidthButtons]="true"
  [poupWidth] = "'max-w-2xl'"
  [closeButtonText]="false"
  [confirmButtonText]="'Continue'"
  [confirmButtonTextCss]="'poppinsSemiBold text-primary_Bg_Btn_Text_color text-sm bg-primary_Bg_Button_Color py-3 rounded-xl'"
  (confirmButtonClick)="resumeExaminatioTimer()"
>
 <h1 class="text-2xl text-primary_Text_Color my-2 font-semibold">
      Verify Your Surroundings
    </h1>

    <div class="w-full flex justify-center">
      <span class="box w-[262.5px]">
        <!-- <qrcode [qrdata]="linkForQrCode" [width]="258" [errorCorrectionLevel]="'M'"></qrcode> -->
        <img class="ml-6" [src]="linkForQrCode" />
      </span>
      <!-- <img [src]="_commonService.Images.QR_CODE" class="w-[230px] " alt=""> -->
    </div>

    <p class="text-secondary_Light_Text_Color">
      Please move your mobile device in your surroundings to ensure that you're
      in a proper environment for the exam.
    </p>

    <p class="mt-5 mb-2 text-secondary_Light_Text_Color">
      Please make sure you are following the below requirements:
    </p>
    <ul class="list-disc ml-5 text-secondary_Light_Text_Color">
      <li>No other person is present in the room.</li>
      <li>Your desk is clear of any unauthorized materials.</li>
      <li>Your computer screen is visible in the recording.</li>
    </ul>
</app-common-popup>
<!--  Verify Surroundings Modal ends -->

<!-- Multiple Display Warning Popup -->
<!-- <div *ngIf="multipleDisplayWarning" class="overlay">
  <div class="popupForRefreshPopup bg-white !p-6">
    <img [src]="_commonService.Images.MULTIPLE_DISPLAY" alt="" class="mx-auto" />
    <h1 class="text-2xl text-primary_Text_Color my-4">
      {{ _commonService.Enums.MULTIPLE_SCREEN }}
    </h1>
    <p class="text-secondary_Light_Text_Color mt-5">
      {{ _commonService.Enums.PAUSED_MULTIPLE_SCREEN }}
    </p>
  </div>
</div> -->

<!-- Multiple Display Warning Popup starts -->
<app-common-popup
  [isOpen]="multipleDisplayWarning"
  [imageSrc]="_commonService.Images.MULTIPLE_DISPLAY"
  [imageCss]="'h-32 w-32'"
  [closeButtonText]="false"
  [confirmButtonText]="false"
>
 <h1 class="text-2xl text-primary_Text_Color my-4 poppinsSemiBold">
      {{ _commonService.Enums.MULTIPLE_SCREEN }}
  </h1>
  <p class="text-secondary_Light_Text_Color mt-5 poppinsRegular">
      {{ _commonService.Enums.PAUSED_MULTIPLE_SCREEN }}
  </p>
</app-common-popup>
<!-- Multiple Display Warning Popup ends -->

<!-- Background Application detection Warning Popup -->
<!-- <div *ngIf="multipleWindowWarning" class="overlay">
  <div class="popupForRefreshPopup bg-white !p-7 w-full sm:w-1/2 md:w-2/5 2xl:w-[30%]">
    <img [src]="_commonService.Images.BACKGROUND_APPS" alt="" class="mx-auto" />
    <h1 class="text-2xl text-primary_Text_Color my-4 poppinsMedium">
      {{ _commonService.Enums.BACKGROUND_APPLICATIONS }}
      <span class="poppinsSemiBold">{{ matchingApps }}</span>
    </h1>
    <p class="text-secondary_Light_Text_Color mt-5">
      {{ _commonService.Enums.PAUSED_BACKGROUND_APPLICATIONS }}
    </p>
  </div>
</div> -->


 <!-- Background Application detection Warning Popup starts -->
<app-common-popup
  [isOpen]="multipleWindowWarning"
  [imageSrc]="_commonService.Images.BACKGROUND_APPS"
  [imageCss]="'h-32 w-32'"
  [closeButtonText]="false"
  [confirmButtonText]="false"
>
 <h1 class="text-2xl text-primary_Text_Color my-4 poppinsSemiBold">
      {{ _commonService.Enums.BACKGROUND_APPLICATIONS }}
      <span class="poppinsSemiBold">{{ matchingApps }}</span>
  </h1>
  <p class="text-secondary_Light_Text_Color mt-5 poppinsRegular">
      {{ _commonService.Enums.PAUSED_BACKGROUND_APPLICATIONS }}
  </p>
</app-common-popup>
<!--Background Application detection Warning Popup ends -->



<!-- Ecternal Devices detection Warning Popup -->
<!-- <div *ngIf="externalDeviceWarning" class="overlay"> -->
  <!-- <div class="popupForRefreshPopup bg-white !p-7 w-full sm:w-1/2 md:w-2/5 2xl:w-[30%]"> -->
    <!-- <img [src]="_commonService.Images.EXTERNAL_DEVICE" alt="" class="mx-auto" /> -->
    <!-- <h1 class="text-2xl text-primary_Text_Color my-4 poppinsMedium">
      External device detected -->
      <!-- <span class="poppinsSemiBold">{{externalDeviceLable}}</span> -->
    <!-- </h1> -->
    <!-- <p class="text-secondary_Light_Text_Color mt-3">
      The assessment has been paused due to detection of the following external
      device(s):
      <span class="!font-bold block my-1" *ngFor="let device of externalDeviceLable">
        • {{ device }}
      </span>
      Please ensure no external camera or speaker is connected.
    </p> -->
  <!-- </div> -->
<!-- </div> -->

<!-- External Devices detection Warning Popup starts -->
<app-common-popup
  [isOpen]="externalDeviceWarning"
  [imageSrc]="_commonService.Images.EXTERNAL_DEVICE"
  [imageCss]="'h-32 w-32'"
  [heading]="' External device detected !'"
  [headingCss]="'text-center text-primary_Text_Color text-xl poppinsSemiBold mb-2 '"
  [closeButtonText]="false"
  [confirmButtonText]="false"
>
 <!-- <span class="poppinsSemiBold">{{externalDeviceLable}}</span> -->
<p class="text-secondary_Light_Text_Color poppinsRegular mt-3">
   The assessment has been paused due to detection of the following external
   device(s):
   <span class="!font-bold block my-1" *ngFor="let device of externalDeviceLable">
     • {{ device }}
   </span>
   Please ensure no external camera or speaker is connected.
 </p>
</app-common-popup>
<!-- External Devices detection Warning Popup ends -->

<!-- Verify Surrounding Modal -->

<!--Mobile Network Connection Popup -->
<!-- <div *ngIf="mobileConnectionModal" class="overlay">
  <div
    class="popupForNetworkError bg-white sm:w-1/2 md:w-2/5 2xl:w-1/3 rounded-2xl p-5"
  >
    <h1 class="text-xl text-primary_Text_Color my-4 text-center">
      <img
        [src]="_commonService.Images.MOBILE_ERROR"
        alt=""
        class="mx-auto w-1/2"
      />
      <h1 class="my-2">No Internet Connection</h1>
    </h1>
    <p
      class="text-secondary_Light_Text_Color text-base my-4 poppinsLight text-center leading-7"
    >
      We are not able to connect with your mobile device, Please check your
      mobile internet connection. <br />
      You need an active connection to continue your assessment.
    </p>
    <div class="flex justify-center my-3">
      <app-button
      (buttonClick)="mobileConnectionModal = false"
      [class]="
      'bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color py-2.5 rounded-md text-primary_Text_Color font-semibold tracking-wide px-6 mt-4 ml-4'
    "
        [innerText]="'Continue'"
      ></app-button>
    </div>
  </div>
</div> -->

<!--Scan QR Code Popup -->
<!-- <div *ngIf="true" class="overlay"> -->
  <!-- <div class="popupForNetworkError bg-white sm:w-1/2 md:w-2/5 2xl:w-1/3 rounded-2xl p-4 relative"> -->
    <!-- <img
      (click)="scanQRCodeModal = false"
      [src]="_commonService.Images.CLOSE_ICON"
      alt=""
      class="absolute w-6 h-6 cursor-pointer right-[2%] top-[3%]"
    /> -->
    <!-- <img (click)="scanQRCodeModal = false" class="absolute w-6 h-6 cursor-pointer right-[2%] top-[3%]"
      [src]="_commonService.imageBase64String.closeIconBase64String" alt="" />
    <h1 class="text-xl text-primary_Text_Color my-4 text-center">
      <h1 class="my-2">Mobile Setup</h1>
    </h1>
    <p class="text-secondary_Light_Text_Color text-base my-4 poppinsLight text-center leading-7">
      Scan the QR Code and follow the link to activate through your phone.
    </p>

    <div class="w-full flex justify-center pb-10 mt-2">
      <span class="box w-[262.5px]">
        <img class="ml-6" [src]="linkForQrCode" />
      </span>
    </div> -->

    <!-- <div class="flex justify-end mt-6">
      <app-button
        (buttonClick)="scanQRCodeModal = false"
        [class]="
          'bg-white border border-card_Bg_Color py-2.5 text-center px-8 font-semibold rounded-xl ml-4'
        "
        [innerText]="'Close'"
      ></app-button>
    </div> -->
  <!-- </div> -->
<!-- </div> -->

<!--Scan QR Code Popup starts -->
<app-common-popup
  [isOpen]="scanQRCodeModal"
  [closeButtonText]="false"
  [confirmButtonText]="false"
>
  <img (click)="scanQRCodeModal = false" class="absolute w-6 h-6 cursor-pointer right-[2%] top-[3%]"
    [src]="_commonService.imageBase64String.closeIconBase64String" alt="" />
  <h1 class="text-xl text-primary_Text_Color my-4 text-center">
    <h1 class="my-2">Mobile Setup</h1>
  </h1>
  <p class="text-secondary_Light_Text_Color text-base my-4 poppinsLight text-center leading-7">
    Scan the QR Code and follow the link to activate through your phone.
  </p>

  <div class="w-full flex justify-center pb-10 mt-2">
    <span class="box w-[262.5px]">
      <img class="ml-6" [src]="linkForQrCode" />
    </span>
  </div>
</app-common-popup>
<!--Scan QR Code Popup ends -->

<!-- Verify User Response Modal -->
<div *ngIf="verifyUserResponseModal" class="overlay" [ngClass]="
    openPopUp || openPopUpForVideoQuestion || openConfirmationPopup
      ? '!z-40'
      : '!z-50'
  ">
  <div class="popupForReportQuestion bg-white !w-11/12 border-2 border-card_Bg_Color">
    <div class="">
      <h1 class="text-2xl text-primary_Text_Color my-2">
        We are interested to learn how you think...
      </h1>
    </div>

    <div class="grid grid-cols-2 border-card_Bg_Color border-[1px] rounded-xl mt-6">
      <div class="p-4 border-r border-card_Bg_Color overflow-auto h-[60vh]">
        <h1 class="text-secondary_Light_Text_Color text-sm poppinsRegular tracking-wider">
          Question : 1
        </h1>

        <div *ngIf="
            selectedQuestionForExplanation?.questionDto?.questionContentDto
          " class="max-h-[45vh] 2xl:max-h-[50vh] overflow-auto">
          <ng-container *ngFor="
              let orderElement of selectedQuestionForExplanation?.questionDto
                ?.questionContentDto?.OrderOfElement
            ">
            <!-- Render Text -->
            <ng-container *ngIf="orderElement === 'Text'">
              <p class="text-primary_Text_Color poppinsRegular py-2.5 leading-[26px]">
                <markdown katex [data]="
                    selectedQuestionForExplanation?.questionDto
                      ?.questionContentDto?.Text
                  " [disableSanitizer]="false"></markdown>
              </p>
            </ng-container>

            <!-- Render Image -->
            <ng-container *ngIf="orderElement === 'Image'">
              <ng-container *ngFor="
                  let img of selectedQuestionForExplanation?.questionDto
                    ?.questionContentDto?.ImageBase64?.length > 0
                    ? selectedQuestionForExplanation?.questionDto
                        ?.questionContentDto?.ImageBase64
                    : selectedQuestionForExplanation?.questionDto
                        ?.questionContentDto?.Image
                ">
                <img [src]="img" alt="Question Image" class="my-2 cursor-zoom-in" (click)="openImageModal(img)" />
              </ng-container>
            </ng-container>

            <!-- Render Table -->
            <ng-container *ngIf="orderElement === 'Table'">
              <div *ngFor="
                  let table of selectedQuestionForExplanation?.questionDto
                    ?.questionContentDto?.Table
                " class="pb-7 pt-2 pr-3 text-primary_Text_Color poppinsRegular leading-[26px]">
                <p class="pb-1 poppinsSemiBold">
                  <markdown katex [data]="table?.Title" [disableSanitizer]="false"></markdown>
                </p>
                <p>
                  <markdown katex [data]="table?.Table_Description" [disableSanitizer]="false"></markdown>
                </p>

                <table class="custom-table my-2">
                  <thead>
                    <tr>
                      <th *ngFor="let headerItem of table?.Header" class="poppinsSemiBold">
                        <markdown katex [data]="headerItem" [disableSanitizer]="false"></markdown>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of table?.Values">
                      <td *ngFor="let cell of row">
                        <markdown katex [data]="cell" [disableSanitizer]="false"></markdown>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-container>

            <!-- Render SQL Schema -->
            <ng-container *ngIf="
                orderElement === 'Schema' &&
                selectedQuestionForExplanation?.questionDto?.questionType ===
                  'SQL_CODING'
              ">
              <p class="text-primary_Text_Color poppinsRegular py-3 leading-[26px]">
                <markdown katex [data]="
                    selectedQuestionForExplanation?.questionDto
                      ?.questionContentDto?.Schema
                  " [disableSanitizer]="false"></markdown>
              </p>
            </ng-container>

            <!-- Special Handling for Audio Questions -->
            <ng-container *ngIf="
                selectedQuestionForExplanation?.questionDto?.questionType ===
                'AUDIO'
              ">
              <!-- <img
                class="mx-auto max-w-[60vh] min-w-[50vh]"
                [src]="_commonService.Images.BOT_IMAGE"
                alt=""
              /> -->
              <img class="mx-auto max-w-[60vh] min-w-[50vh]"
                [src]="_commonService.imageBase64String.botImageBase64String" alt="" />
            </ng-container>
          </ng-container>

          <!-- Enlarged Image Modal -->
          <div class="modal-background" *ngIf="isEnlargeImage" (click)="closeEnlargedImage()">
            <div class="modal-content">
              <img [src]="_commonService.imageBase64String.closeIconBase64String" alt=""
                class="absolute w-8 h-8 cursor-pointer right-[6%]" (click)="closeEnlargedImage()" />
              <img [src]="enlargedImageUrl" alt="Enlarged Image" class="enlarged-image"
                (click)="closeEnlargedImage()" />
            </div>
          </div>
        </div>

        <!-- Selected Option -->
        <p class="uppercase tracking-wider text-secondary_Light_Text_Color text-base poppinsMedium mt-2">
          Your Answer
        </p>

        <p *ngIf="
            allQuestionsData?.questionType === 'SQL_CODING' ||
            allQuestionsData?.questionType === 'CODING_TYPE' ||
            allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK'
          " class="text-primary_Text_Color text-base mt-2">
          <markdown katex [data]="selectedQuestionForExplanation?.sourceCode" [disableSanitizer]="true">
          </markdown>
        </p>

        <p *ngIf="
            allQuestionsData?.questionType != 'SQL_CODING' &&
            allQuestionsData?.questionType != 'CODING_TYPE' &&
            allQuestionsData?.questionType !== 'JUPYTER_NOTEBOOK'
          " class="text-primary_Text_Color text-base mt-2">
          <markdown katex [data]="
              getSelectedOption(
                selectedQuestionForExplanation?.selectedOptionsIds
              )
            " [disableSanitizer]="true">
          </markdown>
        </p>
      </div>

      <div class="col-span-1 px-6 py-4 question-section-height overflow-auto">
        <div class="w-full xl:h-[30%] 2xl:h-[45vh]">
          <div class="mb-3 flex justify-between">
            <p class="poppinsMedium text-secondary_Light_Text_Color">
              Can you please record a video explaining <br />
              how you arrived at Option <b>{{ selectedOption }}</b> for this
              question.
            </p>
            <p class="text-base">Max Time: 3 mins</p>
          </div>
          <div class="relative">
            <div *ngIf="!recordedFilePreviewUrl && recorderOne">
              <video #displayVideoSetup class="rounded-lg fixed-dimensions-assessment-video" playsinline autoplay muted
                disablePictureInPicture disableRemotePlayback preload="metadata"></video>
            </div>

            <div *ngIf="recordedFilePreviewUrl && !isRecording">
              <video [src]="recordedFilePreviewUrl" class="rounded-lg fixed-dimensions-assessment-video" playsinline
                controls muted disablePictureInPicture disableRemotePlayback preload="metadata"></video>
            </div>

            <div [ngClass]="
                recorderOne && !recordedFilePreviewUrl ? 'overlay-video' : ''
              "></div>
            <div *ngIf="!isRecording && !recorderOne">
              <video id="videoPlayer" controls class="rounded-lg fixed-dimensions-assessment-video"
                disablePictureInPicture disableRemotePlayback preload="metadata"></video>
            </div>

            <div *ngIf="isRecording">
              <video #displayRecording class="rounded-lg fixed-dimensions-assessment-video" playsinline autoplay muted
                disablePictureInPicture disableRemotePlayback preload="metadata"></video>
            </div>
            <div *ngIf="isRecording" class="flex gap-3 absolute -bottom-7 left-[45%]">
              <button (click)="stopRecordingVideo()">
                <app-svg-icon [name]="
                    _commonService.imageBase64String.stopRecordVideoBase64String
                  "></app-svg-icon>
                <!-- <img
                  [src]="_commonService.Images.STOP_RECORD_VIDEO"
                  alt="stop"
                /> -->
              </button>
            </div>
            <!-- <div
              *ngIf="recorderOne && !recordedFilePreviewUrl"
              class="flex gap-3 absolute top-[45%] left-[18%] lg:left-[28%] xl:left-[33%] 2xl:left-[38%]"
            >
              <button
                (click)="startRecordingVideo()"
                class="text-white whitespace-nowrap bg-red-500 px-6 py-2 rounded-full flex gap-2 justify-center items-center z-50"
              >
                <span
                  ><img
                    [src]="_commonService.imageBase64String.startRecordVideoBase64String"
                    alt="start"
                /></span>
                Start Recording
              </button>
            </div> -->
          </div>
          <div class="flex justify-center items-center mt-3"
            *ngIf="(!isRecording && !recorderOne) || recordedFilePreviewUrl">
            <button (click)="startRecordingVideo()"
              class="text-white whitespace-nowrap bg-primary_Text_Color px-2 py-1 rounded-full flex gap-1 justify-center items-center">
              <span>
                <app-svg-icon [name]="
                    _commonService.imageBase64String
                      .startRecordVideoBase64String
                  "></app-svg-icon>
                <!-- <img
                  [src]="_commonService.imageBase64String.startRecordVideoBase64String"
                  alt="start"/> -->
              </span>
              Record Again
            </button>
          </div>
          <div *ngIf="isRecording" class="mt-8 2xl:mt-12 text-center">
            <p>Recording Response</p>
            <p>{{ formatTime(recordingTime) }} / 03:00 min</p>
          </div>
        </div>
      </div>
    </div>

    <div class="flex justify-end mt-5">
      <app-button [class]="
          'bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color py-3 rounded-xl  font-semibold tracking-wide px-7'
        " (buttonClick)="submitVerifiedResponse()" [innerText]="'Submit'"></app-button>
    </div>
  </div>
</div>

<app-container *ngIf="breakTimeScreen" appNoF5Directive (f5Pressed)="handleF5Pressed($event)">
  <div class="my-10">
    <div class="relative w-full mx-auto">
      <h1 class="main-heading mb-6 text-center">
        Relax, take a deep breath. Get ready!!
      </h1>
      <div class="cardStyleForInstall">
        <div class="py-6">
          <div class="mt-10 mx-auto">
            <div class="w-full relative">
              <!-- <img
                [src]="_commonService.Images.ASSESSMENT_ECLIPS"
                class="w-44 h-auto block mx-auto"
                alt=""
              /> -->
              <img class="w-44 h-auto block mx-auto" [src]="
                  _commonService.imageBase64String.assessmentEclipsBase64String
                " alt="" />
              <!-- <img
                [src]="_commonService.Images.READY_ASSESSMENT"
                class="w-28 absolute top-1/2 left-1/2"
                style="transform: translate(-50%, -50%)"
                alt=""
              /> -->
              <img class="w-28 absolute top-1/2 left-1/2" style="transform: translate(-50%, -50%)" [src]="
                  _commonService.imageBase64String.readyAssessmentBase64String
                " alt="" />
            </div>
            <h2 class="main-heading my-5">{{ nextSectionName }}</h2>

            <div class="flex mb-4 justify-center xs:pl-1 sm:pl-0">
              <!-- <img src="" alt=""> -->

              <img [src]="_commonService.imageBase64String.checkMarkBase64String" [ngClass]="'my-auto'" alt="" />
              <span class="text-secondary_Light_Text_Color xs:text-xs sm:text-base ml-2">{{ totalQuestionForNextSection
                }} Questions</span>
              <span class="text-card_Bg_Color mx-3">|</span>
              <!-- <img [src]="_commonService.Images.CHECKMARK_ICON" alt="checkmark" class="my-auto"> -->
              <img [src]="_commonService.imageBase64String.checkMarkBase64String" [ngClass]="'my-auto'" alt="" />
              <span class="text-secondary_Light_Text_Color xs:text-xs sm:text-base ml-2">{{ totalTimeForSection }}
                mins</span>
            </div>
          </div>
          <hr class="text-card_number_color" />
        </div>

        <div class="my-4 flex justify-center gap-2">
          <div>
            <span class="timeCounter">{{ displayMinutes }}</span>
            <p class="mt-3 text-secondary_Light_Text_Color text-center text-xs">
              MIN
            </p>
          </div>
          <span class="text-secondary_Light_Text_Color mt-4">:</span>
          <div>
            <span class="timeCounter ml-1">{{ displaySeconds }}</span>
            <p class="mt-3 text-secondary_Light_Text_Color text-xs text-center">
              SEC
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-container>

<ng-template #iconRef let-label="label" let-conditionCheck="conditionCheck">
  <img [src]="
      conditionCheck
        ? _commonService.Images.CORRECT_TICK_ICON_GREEN
        : _commonService.Images.CORRECT_TICK_ICON_GREY
    " alt="" class="mr-3 mt-1" />
  <!-- <app-svg-icon
    [style.color]="conditionCheck ? '#05A660' : 'grey'"
    [name]="_commonService.Images.CORRECT_TICK_ICON_NEW"
    class="mr-3 mt-1"
  ></app-svg-icon> -->
</ng-template>

<!-- Modal Backdrop -->
<!-- <div *ngIf="false" class="overlay"> -->
  <!-- <div class="popupForRefreshPopup !p-9 !w-1/3 bg-white"> -->
    <!-- <h1 class="text-2xl text-primary_Text_Color mt-4">
      Ready to finally submit?
    </h1> -->
    <!-- <img src="/assets/gifs/warning.gif" alt="" class="mx-auto w-14 h-14" /> -->

    <!-- <p class="text-primary_Text_Color text-base text-center">

      You've left
      <span class="font-bold text-red-600">{{ unattemptedCount }}</span>
      {{ unattemptedCount === 1 ? "question" : "questions" }} unanswered. Would
      you like to go back and review, or continue with submission?
    </p> -->

    <!-- <p class="text-secondary_Light_Text_Color text-base !font-light text-center py-5">
      We noticed there were some questions left
      <span class="font-extrabold italic">unanswered</span> by you in this
      segment.
    </p> -->

    <!-- <div class="flex justify-center gap-6 mt-4">
      <app-button [btnType]="'button'" [class]="
          'text-btn_text_blue_color py-2 px-4 rounded-xl border-2 border-attempt_test_border_color bg-white_color'
        " (buttonClick)="showUnattemptedModal = false" [innerText]="'Go Back'"></app-button>

      <app-button (buttonClick)="confirmSubmit()" [class]="
          'py-3 px-4 rounded-xl tracking-wide bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color'
        " [innerText]="'Submit & Proceed Ahead'"></app-button>
    </div>
  </div> -->
<!-- </div> -->

<!-- showUnattemptedModal popup starts -->
<app-common-popup
  [isOpen]="showUnattemptedModal"
  [headingCss]="'text-center text-primary_Text_Color text-xl poppinsSemiBold mb-2 '"
  [isFullWidthButtons] = "true"
  [closeButtonTextCss]="'text-slate-600 text-sm border-slate-300 shadow-sm  poppinsSemiBold py-3 rounded-xl'"
  [confirmButtonTextCss]="'poppinsSemiBold text-primary_Bg_Btn_Text_color text-sm bg-primary_Bg_Button_Color py-3 rounded-xl'"
  [closeButtonText]="'Go Back'"
  [confirmButtonText]="'Submit & Proceed Ahead'"
  (onClose)="goBack()"
  (onConfirm)="confirmSubmit()"
> 
  <h1 class="text-2xl text-primary_Text_Color poppinsSemiBold mt-4">
      Ready to finally submit ?
  </h1>
   <!-- <img src="/assets/gifs/warning.gif" alt="" class="mx-auto w-14 h-14" /> -->

    <!-- <p class="text-primary_Text_Color text-base text-center">

      You've left
      <span class="font-bold text-red-600">{{ unattemptedCount }}</span>
      {{ unattemptedCount === 1 ? "question" : "questions" }} unanswered. Would
      you like to go back and review, or continue with submission?
    </p> -->
  <p class="text-secondary_Light_Text_Color text-base poppinsRegular  text-center py-5">
      We noticed there were some questions left
      <span class="font-extrabold italic">unanswered</span> by you in this
      segment.
  </p>
</app-common-popup>
<!-- showUnattemptedModal popup ends -->

<!-- Technical Error Modal -->
<!-- <div *ngIf="false" class="overlay">
  <div class="popupForRefreshPopup !p-9 bg-white w-full sm:w-1/2 2xl:w-[40%]">
    <div *ngIf="networkConnection">
      <h1 class="text-2xl text-primary_Text_Color mt-4">
        Temporary Technical Issue
      </h1>
      <p class="text-secondary_Light_Text_Color text-base !font-light text-center py-5">
        We're experiencing a temporary technical issue on our end. Please try
        again later or contact support if the problem persists.
      </p>
    </div>

    <div *ngIf="!networkConnection">
      <h1 class="text-2xl text-primary_Text_Color mt-4">
        No Internet Connection
      </h1>
      <p class="text-secondary_Light_Text_Color text-base !font-light text-center py-5">
        It seems your internet connection has been lost. Please check your
        connection and try reconnecting. If the issue persists, please contact
        support.
      </p>
    </div>

    <img [src]="_commonService.Images.OFFLINE_IMAGE_3" alt="" class="mx-auto w-64" />

    <div class="flex justify-center gap-6 mt-4">
      <app-button (buttonClick)="navToDriveHomePage()" [class]="
          'py-3 px-4 rounded-xl tracking-wide bg-primary_Bg_Button_Color text-primary_Bg_Btn_Text_color'
        " [innerText]="'Exit Assessment'"></app-button>
    </div>
  </div>
</div> -->
<!-- Technical Error Modal starts -->
<app-common-popup
  [isOpen]="technicalErrorModal"
  [headingCss]="'text-center text-primary_Text_Color text-xl poppinsSemiBold mb-2 '"
  [isFullWidthButtons] = "true"
  [confirmButtonTextCss]="'poppinsSemiBold text-primary_Bg_Btn_Text_color text-sm bg-primary_Bg_Button_Color py-3 rounded-xl'"
  [closeButtonText]="false"
  [confirmButtonText]="'Exit Assessment'"
  (onConfirm)="navToDriveHomePage()"
>
<div *ngIf="networkConnection">
      <h1 class="text-2xl text-primary_Text_Color">
        Temporary Technical Issue
      </h1>
      <p class="text-secondary_Light_Text_Color text-base !font-light text-center py-5">
        We're experiencing a temporary technical issue on our end. Please try
        again later or contact support if the problem persists.
      </p>
    </div>

    <div *ngIf="!networkConnection">
      <h1 class="text-2xl text-primary_Text_Color mt-4">
        No Internet Connection
      </h1>
      <p class="text-secondary_Light_Text_Color text-base !font-light text-center py-5">
        It seems your internet connection has been lost. Please check your
        connection and try reconnecting. If the issue persists, please contact
        support.
      </p>
    </div>

<img [src]="_commonService.Images.OFFLINE_IMAGE_3" alt="" class="mx-auto w-64" />
</app-common-popup>
<!-- Technical Error Modal ends -->

<!-- IDE Frame modal -->
<!-- <div *ngIf="IDECodeOutput" class="overlay">
  <div
    class="popupForNetworkError bg-black w-[98%] rounded-md p-8 relative"
  >
    <img
      (click)="IDECodeOutput = false"
      [src]="_commonService.Images.CLOSE_ICON"
      alt=""
      class="absolute w-6 h-6 cursor-pointer right-[1%] top-[1%]"
    />
    <div class="ide-container">
      <iframe src="http://localhost:4200" frameborder="0" class="ide-iframe"></iframe>
    </div>

  </div>
</div> -->

<div *ngIf="showLoader && !maximizeQuestionSection && !breakTimeScreen && !isFullWidthIDEQuestion"
  class="absolute inset-0 z-40 flex flex-col items-center justify-center bg-[#000000e6] text-white rounded top-[9rem] card-container"
  [ngClass]="
    allQuestionsData?.questionType === 'IDE_TYPE'
      ? minimizeQuestionSection
        ? ['w-[75%]', 'left-[22%]', 'right-0']
        : ['w-[93%]', 'left-12']
      : minimizeQuestionSection
      ? ['w-[47%]', 'left-1/2', 'right-0']
      : ['w-[93%]', 'left-12']
  ">
  <!-- <div class="mb-4">
    <div
      class="w-12 h-12 border-4 border-attempt_test_preview_btn_bg border-dashed rounded-full animate-spin"
      style="animation-duration: 2s"
    ></div>
  </div>

  <div class="text-xl font-semibold tracking-wide text-center px-4">
    {{ currentLoadingMessage }}
  </div>

  <div class="text-sm text-gray-300 mt-8">
    Please wait while we get things ready for you...
  </div> -->

  <div class="fixed z-50 flex items-center justify-center p-4">
    <div class="relative bg-gray-800 bg-opacity-40 rounded-3xl p-6 w-full max-w-lg card-container-pop-up">
      <div class="bg-white rounded-2xl shadow-2xl p-8 h-[95%] overflow-y-auto">
        <div class="flex items-center justify-center gap-3 mb-8 pl-20 pr-20">
          <div *ngFor="let step of steps; let i = index" class="h-1 flex-1 rounded-full transition-all duration-300"
            [ngClass]="
              i === currentStep
                ? 'bg-primary_Bg_Button_Color'
                : 'bg-setting_ide_popup_gray_colour'
            "></div>
        </div>

        <div class="text-center mb-6">
          <h2 class="text-xl font-semibold text-primary_Text_Color mb-3">
            Setting up the {{allQuestionsData?.questionType == "IDE_TYPE" ? 'IDE' : 'Jupyter Notebook'}} for you, this
            may take up to 3min
          </h2>
          <p class="text-sm text-secondary_Light_Text_Color leading-relaxed">
            <ng-container [ngSwitch]="currentStep">
              <!-- STEP 0 -->
              <ng-container *ngSwitchCase="0">
                <ng-container *ngIf="allQuestionsData?.questionType === 'IDE_TYPE'; else jupyterStep0">
                  Take a deep breath, relax. <br />
                  Your IDE environment is being prepared.
                </ng-container>
                <ng-template #jupyterStep0>
                  Take a deep breath, relax. <br />
                  Your Jupyter Notebook kernel is starting.
                </ng-template>
              </ng-container>

              <!-- STEP 1 -->
              <ng-container *ngSwitchCase="1">
                <ng-container *ngIf="allQuestionsData?.questionType === 'IDE_TYPE'; else jupyterStep1">
                  Once the IDE loads, click <strong>"Trust Certificate"</strong> to continue.
                </ng-container>
                <ng-template #jupyterStep1>
                  Once the notebook opens, select the correct <strong>Python kernel</strong>.
                </ng-template>
              </ng-container>

              <!-- STEP 2 -->
              <ng-container *ngSwitchCase="2">
                <ng-container *ngIf="allQuestionsData?.questionType === 'IDE_TYPE'; else jupyterStep2">
                  Preview will be enabled after libraries are installed (~2 mins). <br />
                  You may start attempting the question.
                </ng-container>
                <ng-template #jupyterStep2>
                  Required libraries are getting installed. <br />
                  Once completed, you can start writing cells.
                </ng-template>
              </ng-container>

            </ng-container>
          </p>

        </div>

        <div class="flex items-center justify-center gap-3 mb-8">
          <button (click)="handleBack()" *ngIf="currentStep != 0" [disabled]="currentStep === 0"
            class="px-6 py-2.5 rounded-lg font-medium text-secondary_Light_Text_Color border border-dashed border-blue_Color disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
            Back
          </button>
          <button *ngIf="currentStep !== 2" (click)="handleNext()"
            class="px-6 py-2.5 rounded-lg font-medium text-primary_Bg_Btn_Text_color bg-primary_Bg_Button_Color transition-colors">
            Next
          </button>
        </div>

        <div class="flex justify-center">
          <div class="sm:w-54 sm:h-32 lg:w-64 lg:h-48 flex items-center justify-center">
            <img [src]="getImageForStep()" alt="IDE setup illustration" class="w-full h-full object-contain" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- IDE Question Full Width -->
<div *ngIf="isFullWidthIDEQuestion" [ngClass]="
    maximizeQuestionSection ? '' : 'border-r-card_Bg_Color border-[1px]'
  " class="overlay mt-4 !z-40">
  <div class="flex gap-3 overflow-auto popupForReportQuestion bg-white !w-[92%]" id="question-container">
    <img (click)="isFullWidthIDEQuestion = false" [src]="_commonService.Images.MINIMIZE_ICON_YELLOW" alt="" title="Close"
      class="absolute h-7 w-7 cursor-pointer right-[2%] top-[3%]" />

    <div class="w-full question-section-height" id="current-question">
      <div class="flex justify-between items-center">
        <h1 class="text-secondary_Light_Text_Color text-sm poppinsMedium">
          Question : {{ currentQuestionIndex + 1 }}
        </h1>
        <!-- <img
                      class="ml-auto cursor-pointer h-7 w-7 mr-3"
                      (click)="toggleMaximizeQuestionSection()"
                      [src]="
                        maximizeQuestionSection
                          ? _commonService.Images.MINIMIZE_ICON
                          : _commonService.Images.MAXIMIZE_ICON
                      "
                      alt=""
                    /> -->
      </div>
      <div>
        <ng-container *ngIf="isCurrentSectionQuestionBank">
          <p class="text-primary_Text_Color poppinsRegular py-2.5 leading-[26px]">
            <markdown katex [data]="allQuestionsData?.questionText" [disableSanitizer]="false"></markdown>
          </p>
        </ng-container>

        <ng-container *ngIf="
            !isCurrentSectionQuestionBank &&
            allQuestionsData?.questionContentDto
          ">
          <ng-container *ngFor="
              let orderElement of allQuestionsData?.questionContentDto
                ?.OrderOfElement
            ">
            <ng-container *ngIf="orderElement === 'Image'">
              <ng-container *ngFor="
                  let img of allQuestionsData?.questionContentDto?.ImageBase64
                    ?.length > 0
                    ? allQuestionsData?.questionContentDto?.ImageBase64
                    : allQuestionsData?.questionContentDto?.Image
                ">
                <img [src]="img" alt="Question Image" class="my-2 cursor-zoom-in" (click)="openImageModal(img)" />
              </ng-container>
            </ng-container>

            <ng-container *ngIf="orderElement === 'Table'">
              <div *ngFor="
                  let table of allQuestionsData?.questionContentDto?.Table
                " class="pb-7 pt-2 pr-3 text-primary_Text_Color poppinsRegular leading-[26px]">
                <p class="pb-1 poppinsSemiBold">
                  <markdown katex [data]="table?.Title" [disableSanitizer]="false"></markdown>
                </p>
                <p>
                  <markdown katex [data]="table?.Table_Description" [disableSanitizer]="false"></markdown>
                </p>

                <table class="custom-table my-2">
                  <thead>
                    <tr>
                      <th *ngFor="let headerItem of table?.Header" class="poppinsSemiBold">
                        <markdown katex [data]="headerItem" [disableSanitizer]="false"></markdown>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of table?.Values">
                      <td *ngFor="let cell of row">
                        <markdown katex [data]="cell" [disableSanitizer]="false"></markdown>

                        <!-- {{ cell ? cell : "-" }} -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-container>

            <ng-container *ngIf="orderElement === 'Text'">
              <div class="flex flex-col max-h-[80vh]">
                <p class="text-primary_Text_Color poppinsRegular py-2.5 leading-[26px] flex-1 text-ellipsis">
                  <markdown katex [data]="allQuestionsData?.questionContentDto?.Text" [disableSanitizer]="false">
                  </markdown>
                </p>
              </div>
            </ng-container>
          </ng-container>

          <!-- Enlarged Image Modal -->
          <div class="modal-background" *ngIf="isEnlargeImage" (click)="closeEnlargedImage()">
            <div class="modal-content">
              <!-- <img
                [src]="_commonService.Images.CLOSE_ICON"
                alt=""
                class="absolute w-8 h-8 cursor-pointer right-[6%]"
              /> -->
              <img class="absolute w-8 h-8 cursor-pointer right-[6%]"
                [src]="_commonService.imageBase64String.closeIconBase64String" alt="" />
              <img [src]="enlargedImageUrl" alt="Enlarged Image" class="enlarged-image"
                (click)="closeEnlargedImage()" />
            </div>
          </div>
          <!-- Enlarged Image Modal -->
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- IDE Extension disable Section -->
<!-- <div
  *ngIf="allQuestionsData?.questionType === 'IDE_TYPE'"
  [ngClass]="minimizeQuestionSection ? 'left-[22%]' : 'left-[4%]'"
  class="h-16 w-16 top-[52%] absolute cursor-not-allowed"
></div> -->
